/*************************************
 *
 * US English Strings
 *
 **************************************/

const en_us = {
    Schedule_document_has_warning_validations: "Schedule document has warning validations",
    View_Campaign_Analytics: "View Campaign Analytics",
    Create_Campaigns: "Create Campaigns",
    Edit_Campaigns: "Edit Campaigns",
    Delete_Campaigns: "Delete Campaigns",
    View_File: "View File",
    Add_File: "Add File",
    Delete_File: "Delete File",
    View_Mobilize: "View Mobilize",
    Delete_Message: "Delete Message",
    Enable_user_effective_Doc: "Enable user effective Doc",
    Approved_by_on: "Approved by: {0} on {1}",
    Rejected_by_on: "Rejected by: {0} on {1}",
    Export_Payroll_is_requested_already_Are_you_sure_you_want_to_ignore_previous_request_and_export: "Export Payroll is requested already. Are you sure you want to ignore previous request and export?",
    select_a_job: "select a job",
    Enable_Probation_Date: "Enable Probation Date",
    Are_you_sure_you_want_to_update_payroll_settings: "Are you sure you want to update payroll settings?",
    Edit_Payroll_Settings: "Edit Payroll Settings",
    Allow_Access_To_All_Job_Postings: "Allow Access To All Job Postings",
    View_Job_Postings: "View Job Postings",
    Add_Job_Postings: "Add Job Postings",
    Edit_Job_Postings: "Edit Job Postings",
    Delete_Job_Postings: "Delete Job Postings",
    Delete_Extra_Day: "Delete Extra Day",
    Day_cannot_be_deleted_because_shifts_are_scheduled: "Day cannot be deleted because shifts are scheduled.",
    Are_you_sure_you_want_to_delete_empty_extra_day: "Are you sure you want to delete empty extra day?",
    Manual_Entries_Report: "Manual Entries Report",
    Allow_for_deletion_of_File_Versions: "Allow for deletion of File Versions",
    Employee_Record_Report: "Employee Record Report",
    Time_Expenses: "Time Expenses",
    Monetary_Expenses: "Monetary Expenses $",
    Report_cannot_include_more_than_1_month_Please_change_your_selected_dates: "Report cannot include more than 1 month. Please change your selected dates.",
    Expense_is_not_allowed_at_this_location: "Expense is not allowed at this location",
    Disable_Expense: "Disable Expense",
    IVR_Call: "IVR Call",
    Adjusted: "Adjusted",
    Phone_number_is_not_valid: "Phone number is not valid",
    Number_is_required: "Number is required.",
    Invalid_characters_Please_enter_numbers_only: "Invalid characters. Please enter numbers only.",
    Number_is_duplicated: "Number is duplicated.",
    PayrollPPAExport: "Payroll PPA Export",
    Assigned_employee_not_exist: "Assigned employee not exist",
    Cannot_unlock_selected_employees_because_payroll_hierarchy_locked: "Cannot unlock selected employee(s), because payroll hierarchy locked",
    Cannot_lock_selected_employees_because_payroll_hirarchy_locked: "Cannot lock selected employee(s), because payroll hirarchy locked",
    Cannot_unlock_selected_employees_because_exported_employee_exist: "Cannot unlock selected employee(s), because exported employee exist",
    Cannot_Unlock_Payroll_Employees: "Cannot Unlock Payroll Employees",
    Cannot_lock_selected_employees_because_employee_unapproved_expenses_exist: "Cannot lock selected employee(s), because employee unapproved expenses exist",
    Cannot_lock_selected_employees_because_employee_unapproved_punchset_exist: "Cannot lock selected employee(s), because employee unapproved punchset exist",
    Cannot_lock_selected_employees_because_supervisor_unapproved_expenses_exist: "Cannot lock selected employee(s), because supervisor unapproved expenses exist",
    Cannot_lock_selected_employees_because_supervisor_unapproved_punchset_exist: "Cannot lock selected employee(s), because supervisor unapproved punchset exist",
    Cannot_lock_selected_employees_because_Missing_punch_exist: "Cannot lock selected employee(s), because Missing punch exist",
    Cannot_Lock_Selected_Employees: "Cannot Lock Selected Employees",
    Cannot_Approve_PunchSet: "Cannot Approve PunchSet",
    Unlock_Payroll_Employees: "Unlock Payroll Employees",
    Are_you_sure_you_want_to_unlock_payroll_employees: "Are you sure you want to unlock payroll employee(s)?",
    Lock_Payroll_Employees: "Lock Payroll Employees",
    Are_you_sure_you_want_to_lock_payroll_employees: "Are you sure you want to lock payroll employee(s)?",
    Add_Expense: "Add Expense",
    Add_PPA_Expense: "Add PPA Expense",
    Update_Expense: "Update Expense",
    Update_PPA_Expense: "Update PPA Expense",
    Delete_PPA_Expense: "Delete PPA Expense",
    Expense_Audit_Records: "Expense Audit Records",
    You_have_not_permission: "You have not permission",
    Allow_Supervisor_To_Approve_Deny_Own_Leave_Requests: "Allow Supervisor To Approve/Deny Own Leave Requests",
    Are_you_sure_you_want_to_clear_all_notifications: "Are you sure you want to clear all notifications?",
    Notifications: "Notifications",
    Not_match_days: "Not match days",
    Specify_Days: "Specify Days",
    Sort_By_Seniority_Date: "Sort By Seniority Date",
    Hide_PunchSet: "Hide PunchSet",
    Show_Day_Data: "Show Day Data",
    Show_Week_Data: "Show Week Data",
    Show_Employee_Data: "Show Employee Data",
    Group_PunchSet_Data_By: "Group PunchSet Data By",
    TimeoffExport: "Timeoff Export",
    Edit_Payroll_After_Lock: "Edit Payroll After Lock",
    Default: "Default",
    Exceptions_Reports: "Exceptions Reports",
    Include_Punch_Photo: "Include Punch Photo",
    Verify_Files_Missing_Prerequisites: "Verify Files Missing Prerequisites",
    Filter_By_Exception: "Filter By Exception",
    Account_Scheduled_Job: "Account Scheduled Job",
    Account_Feature_Setting: "Account Feature Setting",
    Create_New_Timeoff_Filter: "Create New Timeoff Filter",
    Edit_Timeoff_Filter: "Edit Timeoff Filter",
    Job_Timezone: "Job Timezone",
    Enable_Job_Timezone: "Enable Job Timezone",
    Attendance_and_Emergency: "Attendance and Emergency",
    only_letters_hyphens_periods_and_spaces_are_allowed: "only letters, hyphens, periods and spaces are allowed",
    Exclude_PayTypes: "Exclude PayTypes",
    this_paytype_not_allowed_by_role: "this paytype not allowed by role",
    Allowed_Expense_Paytypes: "Allowed Expense Paytypes",
    EmployeeTimecardTab: "Employee Timecard Tab",
    Advertise_Shift_To_Mobile_Users: "Advertise Shift To Mobile Users",
    Invalid_timeframe: "Invalid timeframe",
    after_punch_in: "after punch in",
    and: "and",
    greater_than: "greater than",
    less_than: "less than",
    This_question_will_only_be_asked_after_a_duration_of: "This question will only be asked after a duration of",
    Time_duration_to_trigger_question: "Time duration to trigger question",
    View_Salary_Pay_Compensation: "View Salary Pay Compensation",
    View_Hourly_Pay_Compensation: "View Hourly Pay Compensation",
    Select_Position: "Select Position",
    contact_support: "contact support",
    warning_change_pay_group_context: "Changing pay groups with different pay calendars mid-cycle can result in incorrect pay calculations, and reporting errors. To ensure data integrity, please contact Findd Support to discuss this change before proceeding.",
    warning_change_pay_group_context_as_global_admin: "You are changing the pay group from '{0}' to '{1}' which will change the pay calendar for these employees. If this is for a job that is mid-payroll cycle and there are punchsets that will cross pay calendars, please carefully review timecards before and after proceeding to ensure payroll accuracy. Please contact Findd Support if you have any questions.",
    Apply_Auto_Breaks: "Apply Auto Breaks",
    Allow_GeoFence_Notifications: "Geofence Boundary Notifications (Personal Device Only)",
    Employee_Locked: "Employee Locked",
    Cannot_Employee_Lock_Payroll: "Cannot Employee Lock Payroll",
    Payroll_Time_Employee_Lock_Warning: "This hierarchy contains {0} timecards that are currently being modified which may exclude those times. Payroll cannot be employee locked while these employees are being changed.",
    Cannot_employee_unlock_for_locked_hierarchy: "Cannot employee unlock for locked hierarchy",
    Are_you_sure_you_want_to_employee_unlock_payroll_hierarchy: "Are you sure you want to employee unlock payroll hierarchy?",
    Are_you_sure_you_want_to_employee_unlock_payroll_hierarchies: "Are you sure you want to employee unlock {0} payroll hierarchies?",
    Employee_Unlock_Payroll_Hierarchy: "Employee Unlock Payroll Hierarchy",
    Are_you_sure_you_want_to_employee_lock_payroll_hierarchy: "Are you sure you want to employee lock payroll hierarchy?",
    Are_you_sure_you_want_to_employee_lock_payroll_hierarchies: "Are you sure you want to employee lock {0} payroll hierarchies?",
    Employee_Lock_Payroll_Hierarchy: "Employee Lock Payroll Hierarchy",
    Payroll_employee_locked_successfully: "Payroll was employee locked successfully!",
    Payroll_employee_unlocked_successfully: "Payroll was employee unlocked successfully!",
    Failed_to_employee_lock_payroll_Please_try_again_later: "Failed to employee lock payroll. Please try again later",
    Failed_to_employee_unlock_payroll_Please_try_again_later: "Failed to employee unlock payroll. Please try again later",
    Employee_Lock: "Employee Lock",
    Employee_Unlock: "Employee Unlock",
    EMP_Locked: "E.Locked",
    Enable_Employee_Lock: "Enable Employee Lock",
    View_Employee_Attributes: "View Employee Attributes",
    Punch_Question_Response_Report: "Punch Question Response Report",
    REJECT_REMOVE: "REJECT & REMOVE",
    HR_Profile: "HR Profile",
    Please_review_the_suspense_punches_before_locking_timecards: "You have outstanding Suspsene Punches for this pay period. Please review the suspense punches before locking timecards.",
    inherited: "inherited",
    inheritance_override: "inheritance override",
    Set_OT_Policy_Manually: "Set OT Policy Manually",
    None_OT_Policy: "None OT Policy",
    Edit_Budget: "Edit Budget",
    Hide_On_ESS: "Hide On ESS",
    Use_Employee_Base_Pay_Rate: "Use Base Pay Rate",
    Base_Pay_Rate_Addition: "Base Pay Rate Addition",
    Use_Pay_Rate_Addition_Percentage: "Use Pay Rate Addition Percentage",
    Base_Pay_Rate_Addition_Percentage: "Pay Rate Addition Percentage",
    Using_Base_Pay_Rate: "Use Base Pay Rate",
    Pay_Rate_Add: "Pay Rate Add",
    Pay_Rate_Percent: "Pay Rate %",
    No_match_position_date: "No match position date",
    Default_OT_Pay_Type: "Default OT Pay Type",
    Default_OT2_Pay_Type: "Default OT2 Pay Type",
    Edit_Profile_Pic: "Edit Profile Pic",
    Edit_Face_Spaces: "Edit Face Spaces",
    View_Attributes: "View Attributes",
    View_Worker_Pool: "View Worker Pool",
    View_Assigned_Employee: "View Assigned Employee",
    View_Job_Devices: "View Job Devices",
    Add_Job_Devices: "Add Job Devices",
    Edit_Job_Devices: "Edit Job Devices",
    Delete_Job_Devices: "Delete Job Devices",
    View_Job_Location: "View Job Location",
    View_Phases: "View Phases",
    View_Positions: "View Positions",
    View_Expenses: "View Expenses",
    View_Photos: "View Photos",
    View_Settings: "View Settings",
    View_Bank_Info: "View Bank Info",
    Add_Bank_Info: "Add Bank Info",
    Edit_Bank_Info: "Edit Bank Info",
    Delete_Bank_Info: "Delete Bank Info",
    View_Pay_Compensation: "View Pay Compensation",
    Add_Pay_Compensation: "Add Pay Compensation",
    Edit_Pay_Compensation: "Edit Pay Compensation",
    Delete_Pay_Compensation: "Delete Pay Compensation",
    Edit_Termination_Notes: "Edit Termination Notes",
    Delete_Hire_Termination_Audits: "Delete Hire/Termination Audits",
    Allow_Rehire: "Allow Rehire",
    Post_as_Posted_Schedule: "Post as Posted Schedule",
    Present_Timecard_on_Punch_Out: "Present Timecard on Punch Out",
    Action_By_Name: "Action By Name",
    Previous_Pay_Period: "Previous Pay Period",
    Last_Day_Worked: "Last Day Worked",
    Float_Employee_Info: "Float employees are employees who have worked this job within the last 30 days but are not assigned to this job nor have this job as a default.",
    Show_Default_Job_Employees: "Show Default Job Employees",
    Show_Assigned_Employees: "Show Assigned Employees",
    Show_Float_Employees: "Show Float Employees",
    No_Hierarchy_Job_Variations: "No Hierarchy/Job Variations",
    Hierarchy_Job_Variations: "Hierarchy/Job Variations",
    Exclude_Inactive_Employees: "Exclude Inactive Employees",
    Accrual_Used: "Accrual Used",
    Accrual_Earned: "Accrual Earned",
    x_pay_type_is_used_for_the_leave_punch_set_are_you_sure_you_want_to_also_have_it_contribute_to_the_accrual: "'{0}' pay type is used for the leave punch set, are you sure you want to also have it contribute to the accrual?",
    Failed_Exports_Only: "Failed Exports Only",
    Failed_Export: "Failed Export",
    Export_Note: "Export Note",
    Employee_Count_Attempted: "Employee Count Attempted",
    Successful_Exports: "Successful Exports",
    Failed_Exports: "Failed Exports",
    Export_Report: "Export Report",
    No_Payroll_Export_History: "No Payroll Export History",
    Payroll_Export_History: "Payroll Export History",
    Select_Payroll_Hierarchy: "Select Payroll Hierarchy",
    Are_you_sure_you_want_to_recache_timecards_at_x: "Are you sure you want to recache timecards at {0}?",
    Are_you_sure_you_want_to_recalculate_timecards_at_x: "Are you sure you want to recalculate timecards at {0}?",
    Recalculate_Timecards: "Recalculate Timecards",
    Recache_Timecards: "Recache Timecards",
    External: "External",
    External_Approved: "External Approved",
    Enable_External_Supervisor_Approve_Timecard: "Enable External Supervisor Approve Timecard",
    Disable_Location_Exception: "Disable Location Exception",
    Disable_Biometrics_Exception: "Disable Biometrics Exception",
    Select_Additional_Days: "Select Additional Days",
    Copy_Schedule_Template: "Copy Schedule Template",
    Schedule_template_copied_successfully: "Schedule template(s) copied successfully",
    Are_you_sure_you_want_to_un_assign_employee_x_for_selected_days: "Are you sure you want to un assign employee '{0}' for selected days?",
    Un_Assign_Employee: "Un Assign Employee",
    Productive_Time: "Productive Time",
    Non_Productive_Time: "Non-Productive Time",
    Show_Productive_Non_Productive_Time: "Show Productive/Non-Productive Time",
    MULT: "MULT",
    Empty_PayType: "Empty PayType",
    Invalid_PayType: "Invalid PayType",
    EmployeePage: "Employee Page",
    Delete_Question_Answer: "Delete Question Answer",
    Are_you_sure_you_want_to_delete_this_question_answer: "Are you sure you want to delete this question answer?",
    Import_as_Posted_Schedule: "Import as Posted Schedule",
    Are_you_sure_you_want_to_import_schedule_This_cannot_be_undone: "Are you sure you want to import {0} schedules? This cannot be undone.",
    Import_Schedule_Data: "Import Schedule Data",
    Added_an_additional_day_successfully: "Added an additional day successfully",
    Are_you_sure_you_want_to_add_an_additional_day_to_the_end_of_the_schedule: "Are you sure you want to add an additional day to the end of the schedule?",
    Master_Schedule_posted_successfully: "Master Schedule posted successfully",
    Are_you_sure_you_want_to_post_this_master_schedule_for_current_week: "Are you sure you want to post this master schedule for current week?",
    Immediately_Post: "Immediately Post",
    Failed: "Failed",
    Exported_Date: "Exported Date",
    Exported_By: "Exported By",
    Unexported: "Unexported",
    Empty: "Empty",
    failure_export_payroll_hierarchy: "Failure: The '{0}' Payroll Hierarchy contained errors and was not exported.",
    success_export_payroll_hierarchy: "Success: The '{0}' Payroll Hierarchy's time was exported.",
    Execution_Result: "Execution Result",
    export_failed_comment:
        "The payroll export was not successful. The payroll export was reverted and no changes were made. Please download the Export Result to view the error(s), make corrections and re-attempt the export.",
    Download_Export_Result: "Download Export Result",
    Confirm_Export: "Confirm & Export",
    Upon_confirmation_employee_time_will_be_exported: "Upon confirmation, employee time will be exported.",
    Unapproved_employees: "Unapproved employees",
    Exported_employees: "Exported employees",
    You_have_selected_payroll_hierarchies_for_export_This_export_contains_the_following: "You have selected payroll hierarchies for export. This export contains the following:",
    No_payroll_export_scheduled_job: "No payroll export scheduled job",
    Payroll_Export: "Payroll Export",
    ScheduleReport: "Schedule Report",
    Select_Pay_Group: "Select Pay Group",
    Manual_Override: "Manual Override",
    Inherited: "Inherited",
    Job_Settings_PayGroup_Note: "The pay group set here will apply to all employees with this job as their Default Job, unless an employee has a manual pay group override.",
    Hierarchy_Settings_PayGroup_Note: "The pay group set here will be inherited by all employees with a Default Hierarchy at or below his level, unless a hierarchy, job, or employee has an override pay group setting.",
    Are_you_sure_you_want_to_delete_this_language_agreement: "Are you sure you want to delete this language agreement?",
    English_agreement_is_required_by_default: "English agreement is required by default",
    Agreement: "Agreement",
    Agreement_is_empty: "Agreement is empty",
    Cannot_approve_leave_request_because_paytype_invalid: "Cannot approve leave request, because paytype invalid",
    The_PayType_of_leave_request_invalid_for_employee: "The paytype of leave request invalid for employee",
    Payroll_Expenses_Summary: "Payroll Expenses Summary",
    Payroll_Expenses_Combined_with_Time_Data: "Payroll Expenses Combined with Time Data",
    Device_Field: "Device Field",
    Positions_Field: "Positions Field",
    Require_biometrics: "Require biometrics",
    Control_biometric_settings_per_employee: "Control biometric settings per employee",
    Default_PayGroup_of_Payroll_Hierarchy: "Default PayGroup of Payroll Hierarchy",
    Enable_PayGroup_Assign_Employee_Level: "Enable PayGroup Assign Employee Level",
    Pay_Group_Selection: "Pay Group Selection",
    Set_Pay_Group_Manually: "Set Pay Group Manually",
    Loading_Note_Types: "Loading Note Types",
    Profile: "Profile",
    Logout: "Logout",
    CA_Meal_Break_Exception: "CA Meal Break Exception",
    Enable_CA_Meal_Break_Notification: "Enable CA Meal Break Notification",
    On_x_x_added_a_1_day_schedule_delay: "On {0}, {1} added a 1 day schedule delay",
    On_x_x_added_X_days_schedule_delay: "On {0}, {1} added {2} days schedule delay",
    Schedule_delayed_successfully: "Schedule delayed successfully",
    Enter_the_number_of_days_to_delay_the_schedule: "Enter the number of days to delay the schedule",
    x_Schedule_Delay: "{0} Schedule Delay",
    Clone_Shifts: "Clone Shifts",
    Schedule_Delay: "Schedule Delay",
    Exclude_Weekends: "Exclude Weekends",
    Shift_is_on_weekends: "Shift is on weekends",
    Schedule_dates_are_not_match_with_job_dates: "Schedule's dates are not match with job dates",
    Enable_Breadcrumb: "Enable Breadcrumb",
    Speed: "Speed",
    Accuracy: "Accuracy",
    No_Breadcrumb: "No Breadcrumb",
    Breadcrumb: "Breadcrumb",
    You_have_changed_the_client_of_this_schedule_so_that_it_is_no_longer_visible_To_see_the_schedule_go_to_changed_client: "You have changed the client of this schedule so that it is no longer visible. To see the schedule, go to changed client",
    You_have_changed_the_job_of_this_schedule_so_that_it_is_no_longer_visible_To_see_the_schedule_go_to_changed_job: "You have changed the job of this schedule so that it is no longer visible. To see the schedule, go to changed job",
    You_have_changed_the_hierarchy_of_this_schedule_so_that_it_is_no_longer_visible_To_see_the_schedule_change_your_hierarchy_filter_to_x: "You have changed the hierarchy of this schedule so that it is no longer visible. To see the schedule, change your hierarchy filter to '{0}'",
    Schedule_document_has_not_passed_validations: "Schedule document has not passed validations",
    Shift_hierarchy_is_not_match_with_the_hierarchy_of_schedule_document: "Shift's hierarchy is not match with the hierarchy of schedule document",
    Shift_job_is_not_match_with_the_job_of_schedule_document: "Shift's job is not match with the job of schedule document",
    Shift_client_is_not_match_with_the_client_of_schedule_document: "Shift's client is not match with the client of schedule document",
    You_have_changed_the_hierarchy_of_this_shift_template_so_that_it_is_no_longer_visible_To_see_the_shift_template_change_your_hierarchy_filter_to_X: "You have changed the hierarchy of this shift template so that it is no longer visible. To see the shift template, change your hierarchy filter to '{0}'",
    Precise_Location_permission_granted: "Precise Location permission granted",
    This_device_not_uploaded_permission_data: "This device not uploaded permission data",
    Enable_Punch_to_Assigned_Jobs_Only: 'Enable "Punch to Assigned Jobs Only"',
    Budget_Status: "Budget Status",
    Budget_By_Job: "Budget By Job",
    Filter_Only_Favorites: "Filter Only Favorites",
    Please_select_start_end_dates: "Please select start/end dates",
    Calculate_Budget: "Calculate Budget",
    Cannot_calculate_budget_for_more_than_100_Jobs: "Cannot calculate budget for more than 100 Jobs",
    Please_narrow_your_search_criteria_to_fewer_than_100_jobs_to_see_the_calculated_real_time_budget_data: "Please narrow your search criteria to fewer than 100 jobs to see the calculated real-time budget data",
    Multiple_Jobs_Budget_Data: "Multiple Jobs Budget Data",
    View_Budget: "View Budget",
    Filter_By_Clients: "Filter By Clients",
    Current_Job: "Current Job",
    Filter_by_Job_Start_End_Dates: "Filter by Job Start/End Dates",
    Create_New_Job_Filter: "Create New Job Filter",
    Edit_Job_Filter: "Edit Job Filter",
    Type_here: "Type here...",
    inherited_from_Account_x: "inherited from Account: {0}",
    inherited_from_x: "inherited from {0}",
    All_Employees: "All Employees",
    Qualifications: "Qualifications",
    Gig_Pool_Rules: "Gig Pool Rules",
    Gig_Pool: "GigPool",
    Gig_Pool_Empty: "Ready to add your first GigPool? Click the add button.",
    Gig_Pool_Members: "members",
    Employee_Type: "Employee Type",
    Available_Jobs: "Available Jobs",
    DELETE_FACESPACE: "DELETE FACESPACE",
    Are_you_sure_you_want_to_delete_this_Face_Space: "Are you sure you want to delete this 'Face Space'?",
    Create_New_Filter: "Create New Filter",
    Employee_does_not_have_matched_position_with_shift: "Employee does not have matched position with shift",
    LOCATION_exception_description: "Location Punch Exception. Punch occurred {0} from {1}. Please see the map to view where the employee punched compared to where the {2} is located.",
    No_Device_Location_exception_description: "The punch did not capture the GPS location at the time of the punch. On the device, please check the mobile app permissions to ensure the Location Permissions are allowed.",
    Punch_Outside_Geofence: "Punch Outside Geofence",
    Connection_Type: "Connection Type",
    Device_Mode: "Device Mode",
    Employee_Timecard_Report: "Employee Timecard Report",
    Rate: "Rate",
    Accrual_Rate_Per_Day: "Accrual Rate Per Day",
    Per_Hour_Worked: "Per Hour Worked",
    Per_Day: "Per Day",
    Unit: "Unit",
    There_is_no_Budget_Unit_Position_Definition_item: "There is no Budget Unit Position Definition item",
    There_is_no_Budget_Unit_item: "There is no Budget Unit item",
    Unit_Factor: "Unit Factor",
    Add_Budget_Unit_Position_Definition: "Add Budget Unit Position Definition",
    Budget_Units: "Budget Units",
    Use_Schedule_Budget_Units: "Use Schedule Budget Units",
    Budget_Unit_Position_Definitions: "Budget Unit Position Definitions",
    Schedule_Budget_Units: "Schedule Budget Units",
    Unit_Name: "Unit Name",
    Add_Unit: "Add Unit",
    Shift_time_is_out_of_schedule: "Shift time is out of schedule",
    Enable_Mobile_Location_Fraud_Prevention_to_GPS_accuracy: "Enable Mobile Location Fraud Prevention to GPS accuracy",
    Application_Language: "Application Language",
    Job_Hierarchy_Move_Warning: "The following employees currently have '{0}' as their Default Job but do not have permission to the hierarchy that this job is being moved to. Do you wish to remove them from having '{0}' as their default job?",
    Proceed: "Proceed",
    Job_Hierarchy_Move: "Job Hierarchy Move",
    The_punch_level_of_shift_invalid: "The punch level of shift invalid",
    Limit_To_Shift_Position: "Limit To Shift Position",
    Require_Matching_Employee_Shift_Position: "Require Matching Employee Shift Position",
    RequirePhase: "Require Phase",
    One_Hour_Timeoff_Increment: "1 hour Timeoff Increment",
    Punch_is_in_suspense_due_to_pairing_error_Please_approve_or_reject: "Punch is in suspense due to pairing error. Please approve or reject.",
    Punch_hierarchy_is_not_valid_by_employee_permission: "Punch hierarchy is not valid by employee permission",
    Duplicated_occupation_exist: "Duplicated occupation exist",
    Duplicated_badge_exist: "Duplicated badge exist",
    Duplicated_specialty_exist: "Duplicated specialty exist",
    Employee_already_assigned_to_this_job: "Employee already assigned to this job",
    Are_you_sure_you_want_to_delete_this_filter: "Are you sure you want to delete this filter?",
    Punch_to_assigned_Jobs_only: "Punch to assigned Jobs only",
    Work_Instructions: "Work Instructions",
    Resource_Planner_Schedule: "Resource Planner Schedule",
    Daily_Schedule_Budget: "Daily Schedule Budget",
    Create_New_Resource_Planner_Filter: "Create New Resource Planner Filter",
    Edit_Resource_Planner_Filter: "Edit Resource Planner Filter",
    Filter_by_Selected_Positions: "Filter by Selected Positions",
    Filter_by_Selected_Clients: "Filter by Selected Clients",
    Filter_by_Selected_Jobs: "Filter by Selected Jobs",
    Select_Positions: "Select Positions",
    Hide_Core_Staff: "Hide Core Staff",
    Hide_Float_Staff: "Hide Float Staff",
    Hide_Per_Diem_Staff: "Hide Per Diem Staff",
    Hide_Agency_Staff: "Hide Agency Staff",
    View_Only_Productive_Shifts: "View Only Productive Shifts",
    View_Unscheduled_Staff: "View Unscheduled Staff",
    View_Only_Filled_Shifts: "View Only Filled Shifts",
    View_Only_Unfilled_Shifts: "View Only Unfilled Shifts",
    Removed: "Removed",
    Inactivated: "Inactivated",
    Shift_time_is_not_match_with_job_dates: "Shift time is not match with job's dates",
    Cannot_auto_assign_in_here_Schedule_has_the_shift_which_is_not_shown_here: "Cannot auto assign in here. Schedule has the shift which is not shown here",
    Validation_Error: "Validation Error",
    Cannot_copy_in_here_Schedule_has_the_shift_which_is_not_shown_here: "Cannot copy in here. Schedule has the shift which is not shown here",
    Cannot_delete_in_here_Schedule_has_the_shift_which_is_not_shown_here: "Cannot delete in here. Schedule has the shift which is not shown here",
    Cannot_post_in_here_Schedule_has_the_shift_which_is_not_shown_here: "Cannot post in here. Schedule has the shift which is not shown here",
    Resource_Planner_View: "Resource Planner View",
    Punch_Comment: "Punch Comment",
    Minimum_Break_Override: "Minimum Break Override",
    Failed_to_download_payroll_report_Please_try_again_later: "Failed to download payroll report. Please try again later",
    Failed_to_download_payroll_Please_try_again_later: "Failed to download payroll. Please try again later",
    View_Hierarchy_Tab: "View Hierarchy Tab",
    Can_add_non_direct_report_employees: "Can add non-direct report employees",
    Allow_Honor_Based_Time_Entry: "Allow Honor Based Time Entry",
    Pay_Calendars: "Pay Calendars",
    Bi_Weekly_OT: "Bi Weekly OT",
    Bi_Weekly_OT2: "Bi Weekly OT2",
    Bi_Weekly_rule_should_be_not_exist: "Bi Weekly rule should be not exist",
    Cannot_choose_Bi_Weekly: "Cannot choose Bi Weekly",
    Cannot_choose_Bi_Weekly_OT_policy: "Cannot choose Bi Weekly OT policy",
    OT_Policy: "OT Policy",
    Are_you_sure_you_want_to_delete_OT_policy: "Are you sure you want to delete OT policy?",
    OT_Policy_created_successfully: "OT Policy created successfully",
    OT_Policy_updated_successfully: "OT Policy updated successfully",
    OT_Policy_Type: "OT Policy Type",
    New_OT_Policy: "New OT Policy",
    Edit_OT_Policy: "Edit OT Policy",
    Daily_OT: "Daily OT",
    Daily_OT2: "Daily OT2",
    Weekly_OT: "Weekly OT",
    Weekly_OT2: "Weekly OT2",
    ConsecutiveRule_OT: "ConsecutiveRule OT",
    ConsecutiveRule_OT2: "ConsecutiveRule OT2",
    ConsecutiveRule_Days: "ConsecutiveRule Days",
    OT_Policy_Selected: "OT Policy Selected",
    No_OT_Policy: "No OT Policy",
    OT_Policies: "OT Policies",
    Enable_OT_Policy: "Enable OT Policy",
    Use_Rounding_Rules: "Use Rounding Rules",
    Limit_Employees_on_Device_to_Hierarchy: "Limit Employees on Device to Hierarchy",
    Rewards: "Rewards",
    View_Rewards: "View Rewards",
    Add_Rewards: "Add Rewards",
    Edit_Rewards: "Edit Rewards",
    Delete_Rewards: "Delete Rewards",
    Are_you_sure_you_want_to_delete_photo: "Are you sure you want to delete photo(s)?",
    Drag_and_Drop_or_click_to_choose_a_picture_files: "Drag and Drop or click to choose a picture files",
    Add_Photo: "Add Photo",
    Photos: "Photos",
    No_Photo: "No Photo",
    Photo_Selected: "Photo Selected",
    x_Photos_Selected: "{0} Photos Selected",
    Are_you_sure_you_want_to_download: "Are you sure you want to download?",
    NoSelection: "No Selection",
    SingleDate: "Single Date",
    DateRange: "Start & End Dates",
    Date_Selection_Type: "Date Selection Type",
    Please_select_location: "Please select location",
    TimecardTab: "Timecard Tab",
    Report_Location: "Report Location",
    NewCustomReportType: "Add New Custom Report Type",
    TimecardValidationScript: "Timecard Validation Script",
    Limit_By_Job_Shortlist: "Limit By Job Shortlist",
    No_Job_location: "No Job location",
    No_Employee_location: "No Employee location",
    Unknown: "Unknown",
    Include_all_Audit_data: "Include all Audit data",
    Job_Consolidate_Pay_Category_Tooltip: "Represents the overall Category that the hours fall into - Regular (REG), Overtime (OT), and Double Overtime (OT2).",
    Job_Consolidate_PayType_Tooltip:
        "Represents the Type of hours that the employee's time worked is allocated to. Pay Types can fall into the Pay Categories of either Regular, Overtime, or Double Overtime.",
    Pay_Category: "Pay Category",
    Failed_Calculate_Accural_Employees_For_Close_Payroll: "Failed Calculate Accural Employees For Close Payroll",
    Cannot_Delete_Job: "Cannot Delete Job",
    Cannot_Delete_Job_because_it_is_already_use: "Cannot delete job because there is at least one job already in use.",
    Cannot_Inactive_Job: "Cannot Inactive Job",
    Cannot_Inactive_Job_because_it_is_already_use: "Cannot inactive job because it is already in use.",
    Cannot_Inactive_Phase: "Cannot Inactive Phase",
    Cannot_Inactive_Phase_because_it_is_already_use: "Cannot inactive phase because it is already in use.",
    Phase_Removed: "Phase Removed",
    Cannot_Delete_Phase: "Cannot Delete Phase",
    Cannot_Delete_Phase_because_it_is_already_use: "Cannot delete phase because there is at least one phase already in use.",
    Location_permission_granted: "Location permission granted",
    Camera_permission_granted: "Camera permission granted",
    Storage_permission_granted: "Storage permission granted",
    Phone_call_permissions_granted: "Phone call permissions granted",
    NFC_permission_granted: "NFC permission granted",
    Photo_Library_permission_granted: "Photo Library permission granted",
    Device_Permissions: "Device Permissions",
    Only_Lock_Supervisor_Approved: "Only Lock Supervisor Approved",
    Only_Lock_Employee_Approved: "Only Lock Employee Approved",
    Beginning: "Beginning",
    Time_Fraud_Alert: "Time Fraud Alert",
    No_time_fraud_punch_found: "No time fraud punch found",
    Fraud: "Fraud",
    Time_Fraud: "Time Fraud",
    Based_On_Actual_Time: "Based On Actual Time",
    Based_On_Rounded_Time: "Based On Rounded Time",
    Time_Duration_Rule: "Time Duration Rule",
    Bill_Rate_$: "Bill Rate $",
    Pay_Rate_$: "Pay Rate $",
    Reg_Total_$: "Reg Total $",
    OT_Total_$: "OT Total $",
    OT2_Total_$: "OT2 Total $",
    Total_$: "Total $",
    PunchSet_Data: "PunchSet Data",
    Custom_Range: "Custom Range",
    Timeframe: "Timeframe",
    Save_to_Timecard_Reports: "Save to Timecard Reports",
    Report_with_this_name_already_Exists: "Report with this name already Exists",
    Report_updated_successfully: "Report updated successfully",
    Report_saved_successfully: "Report saved successfully",
    Report_deleted_successfully: "Report deleted successfully",
    report_Name: "Report Name",
    Employee_Data: "Employee Data",
    Select_the_data_you_want_to_export_as_unique_columns_in_your_report: "Select the data you want to export as unique columns in your report",
    Adhoc_Report: "Adhoc Report",
    Are_you_sure_you_want_to_delete_selected_file: "Are you sure you want to delete selected file?",
    Added_By: "Added By",
    No_Job: "No Job",
    File_Name: "File Name",
    Upload_New_File_Version: "Upload New File Version. \nDrag and Drop or click to choose a file from your computer.",
    No_File: "No File",
    New_File: "New File",
    File_Selected: "File Selected",
    x_Files_Selected: "{0} Files Selected",
    Files: "Files",
    Hide_OT2: "Hide OT2",
    Exclude_Agency_Employees: "Exclude Agency Employees",
    Exclude_Exempt_Employees: "Exclude Exempt Employees",
    Payroll_by_Job: "Payroll by Job",
    Cannot_approve_by_a_explicit_job_permission: "Cannot approve by a explicit job permission.",
    Cannot_unapprove_by_a_explicit_job_permission: "Cannot unapprove by a explicit job permission.",
    Are_you_sure_you_want_to_approve_punchSet: "Are you sure you want to approve punchSet?",
    Are_you_sure_you_want_to_unapprove_punchSet: "Are you sure you want to unapprove punchSet?",
    Unapprove_PunchSet: "Unapprove PunchSet",
    View_Payroll_By_Job: "View Payroll By Job",
    Account_Level_Clock_Device_Warning_Msg: "Adding this device to the account level will not work for versions of the mobile app older than May 1, 2022.",
    Account_Level_Clock_Device_Job_Limit_Error_Msg:
        "There are too many jobs to register at this level of the hierarchy. Please choose a different hierarchy for registration. Contact the Findd Support team for assistance if you have questions about registering your device.",
    Are_you_sure_you_want_to_reinitialize_the_selected_devices: "Are you sure you want to reinitialize the selected devices?",
    Warning_This_will_act_as_a_fresh_install_and_mobile_data_will_be_deleted: "Warning: This will act as a fresh install and mobile data will be deleted.",
    Init_Devices: "Init Devices",
    Week_Totals: "Week Totals",
    Please_input_the_Billing_Contact_before_add_payment_method: "Please input the Billing Contact before add payment method.",
    Data: "Data",
    Cannot_add_over_10_clients_for_free_account_Please_upgrade_your_account_plan_to_add_more: "Cannot add over 10 clients for free account. Please upgrade your account plan to add more.",
    Cannot_add_over_10_jobs_for_free_account_Please_upgrade_your_account_plan_to_add_more: "Cannot add over 10 jobs for free account. Please upgrade your account plan to add more.",
    Cannot_add_over_100_employees_for_free_account_Please_upgrade_your_account_plan_to_add_more: "Cannot add over 100 employees for free account. Please upgrade your account plan to add more.",
    The_punch_count_reached_to_1000_limit_for_free_account_This_punch_was_in_suspense_state_and_not_added_to_timecard_Please_upgrade_your_account_plan_to_add_this_punch_to_timecard:
        "The punch count reached to 1000 limit for free account. This punch was in suspense state and not added to timecard. Please upgrade your account plan to add this punch to timecard.",
    The_punch_count_reached_to_limit_for_free_account: `The punch count reached to limit for free account. Select "{2}" to add this punch to {0} {1}'s timecard or select "Delete" to delete this punch.`,
    Hide_Paywall: "Hide Paywall",
    Please_select_a_job: "Please select a job",
    Missing_Punch_workflow: "Missing Punch workflow",
    No_pending_workflows: "No pending workflows",
    No_pending_trainings: "No pending trainings",
    Allow_STRIPE_Payment_Method: "Allow STRIPE Payment Method",
    invalid: "invalid",
    Pay_Type_is_not_valid: "Pay Type is not valid",
    View_Rates: "View Rates",
    Edit_Rates: "Edit Rates",
    Reg_OT_OT2_are_0: "Reg, OT and OT2 are 0",
    Reg_OT_are_0: "Reg and OT are 0",
    Not_allowed_0_hour: "Not allowed 0 hour",
    Owner: "Owner",
    Try_it_for_free_today: "Try it for free today!",
    No_cost_to_sign_up_and_get_started: "No cost to sign up and get started.",
    Use_Leave_Tracking_Description: "You can chat with sales now or upgrade to the Findd Professional plan. Start using Findd Leave Tracking today!",
    Use_Schedule_Description: "You can chat with sales now or upgrade to the Findd Professional plan. Let Findd take the guesswork out of your scheduling process!",
    Ready_to_start_using_leave_tracking: "Ready to start using leave tracking?",
    Ready_to_start_using_Scheduling: "Ready to start using Scheduling?",
    Employee_Leave_Tracking: "Employee Leave Tracking",
    Enhanced_Scheduling: "Enhanced Scheduling",
    Talk_to_Sales: "Talk to Sales",
    Enable_IN_OUT_on_Mobile: "Enable IN/OUT on Mobile",
    Trigger_Duration: "Trigger Duration",
    Rule: "Rule",
    Apply: "Apply",
    Duplicate_Budget_Item_Message_Text: "There is already a budget item created of this type.",
    Are_you_sure_you_want_to_accept_suspense_punches: "Are you sure you want to accept suspense punches?",
    Accept_Suspense_Punches: "Accept Suspense Punches",
    Add_missing_punch_from_mobile: "Add missing punch from mobile",
    Edit_punch_time_from_mobile: "Edit punch time from mobile",
    Apply_Once_Per_PunchSet: "Apply Once Per PunchSet",
    Apply_Once_Per_Day_to_the_1st_Qualified_PunchSet: "Apply Once Per Day to the 1st Qualified PunchSet",
    Apply_Once_Per_Day_based_on_Total_Working_Hours: "Apply Once Per Day based on Total Working Hours",
    Cannot_close_current_or_future_period: "Cannot close the current or future period.",
    Select_Jobs: "Select Jobs",
    All_Jobs: "All Jobs",
    Include_Only_Selected: "Include Only Selected",
    Exclude_Only_Selected: "Exclude Only Selected",
    Job_Explicit_Assignment: "Job Explicit Assignment",
    User_Details: "User Details",
    User_Settings: "User Settings",
    QA: "Q&A",
    Cannot_export_because_there_is_no_any_difference: "Cannot export, because there is no any difference.",
    You_have_not_a_permission_to_approve_punchSet: "You have not a permission to approve punchset",
    You_have_not_a_permission_to_approve_expenses: "You have not a permission to approve expenses",
    approve_only_punchset: "This timecard contains both timecard values and expenses. You do not have permission to approve expenses. If you proceed, only timecard values will be approved",
    approve_only_expenses: "This timecard contains both timecard values and expenses. You do not have permission to approve timecard values. If you proceed, only expenses will be approved",
    Punch_has_not_phase: "Punch has not phase.",
    Are_you_sure_you_want_to_modify_this_timecard: "Are you sure you want to modify this timecard?",
    Type_Name: "Type Name",
    Parent_question_not_exist_in_Punch_In: "Parent question not exist in Punch In",
    Parent_question_not_exist_in_Punch_Out: "Parent question not exist in Punch Out",
    Enable_Timecard_Amount_Expenses: "Enable Timecard Amount Expenses",
    Are_you_sure_you_want_to_delete_the_selected_Client_Type: "Are you sure you want to delete the selected Client Type?",
    Client_Type_Selected: "Client Type Selected",
    Abbreviation: "Abbreviation",
    Add_Client_Type: "Add Client Type",
    Edit_Client_Type: "Edit Client Type",
    Abbreviation_is_duplicated: "Abbreviation is duplicated",
    Client_Types: "Client Types",
    Client_Settings: "Client Settings",
    Based_On_Punch: "Based On Punch",
    Based_On_Employee_Default_Hierarchy: "Based On Employee Default Hierarchy",
    Are_you_sure_you_want_to_delete_the_selected_auto_break: "Are you sure you want to delete the selected auto break?",
    Use_Auto_Breaks: "Use Auto Breaks",
    No_Answer: "No Answer",
    Cannot_web_punch_The_IP_Address_is_invalid: "Cannot web punch. The IP Address({0}) is invalid.",
    Suspense_Time: "Suspense Time",
    Reject_Suspense: "Reject Suspense",
    Reject: "Reject",
    Attestation_Text: "Attestation Text",
    Enable_Timecard_Approval_Attestation: "Enable Timecard Approval Attestation",
    Time_Approvals: "Time Approvals",
    required: "required",
    Prevent_Warning: "Prevent Warning",
    Language: "Language",
    Child_Question_Only: "Child Question Only",
    Once_per_day: "Once per day",
    On_every_punch: "On every punch",
    Create_Exception: "Create Exception",
    Exception_Prevent_Punch: "Exception & Prevent Punch",
    Workflow: "Workflow",
    Workflows: "Workflows",
    User_Modified: "User Modified",
    Cannot_choose_invalid_job: "Cannot choose invalid job",
    mobile_update_punch_time_suspense_message: "{0} requested to change time ({1}) from a device {2}. it is in suspense state for review.",
    add_missing_punch_suspense_message: "This punch was added manually by {0} {1} from a mobile device {2}. This punch is in suspense for approval.",
    JobDashboardWorkingEmployeeTooltip: "Employees who are currently punched into this job. \nIf the employee forgets to punch out the employee will be removed from this list after 24 hours.",
    JobDashboardWorkedEmployeeTooltip: "Any employee who has time logged for this job on the day selected.",
    JobDashboardTodayApproachingOvertimeTooltip: "Any employee who worked this job this week, \nwho has 32 to 40 Weekly Total Hours (including hours from jobs other than this job).",
    JobDashboardOldDayApproachingOvertimeTooltip: "Any employee who worked this job on the week selected, \nwho has 32 to 40 Weekly Total Hours (including hours from jobs other than this job).",
    JobDashboardTodayOvertimeTooltip: "Any employee who worked this job this week, \nwho has greater than 40 Weekly Total Hours (including hours from jobs other than this job).",
    JobDashboardOldDayOvertimeTooltip: "Any employee who worked this job on the week selected, \nwho has greater than 40 Weekly Total Hours (including hours from jobs other than this job).",
    No_working_worked_employee_found: "No working/worked employee found",
    Show_All_Employees_With_Time_Today: "Show All Employees With Time Today",
    No_worked_employee_found: "No worked employee found",
    Worked_Employees: "Worked Employees",
    Currently_Working: "Currently Working",
    No_Phase: "No Phase",
    Job_Phases: "Job Phases",
    Allow_Retro_Modifications: "Allow Retro Modifications",
    Change_Location: "Change Location",
    Are_you_sure_you_want_to_change_location: "Are you sure you want to change the location?",
    locked_pay_period_suspense_message_for_lock: `This punch is for {0} which is a date that is already locked by payroll. If this punch needs to be added to the timecard please unlock payroll first. Select "Delete" to delete this punch.`,
    locked_pay_period_suspense_message_for_unlock: `This punch is for {0} which is a date that was locked by payroll. The pay period is now unlocked. Please "Accept" to add this punch to the {1} {2}'s timecard or select "Delete" to delete this punch.`,
    deleted_hierarchy_registered_device_suspense_message: `This punch is in suspense and has not been added to the timecard. The punch was uploaded from clock device which resigstered at a job or hierarchy that has been deleted. Select "Accept" to add this punch to {0} {1}'s timecard or select "Delete" to delete this punch. After accepting, please select a new hierarchy or job for the punch.`,
    delete_device_suspense_message: `This punch is in suspense and has not been added to the timecard. The device that this punch came from was deleted before this punch uploaded from the device. Select "Accept" to add this punch to {0} {1}'s timecard or select "Delete" to delete this punch.`,
    delete_user_suspense_message: `Employee {0} {1} is a deleted user. Cannot add this punch to a timecard for a deleted employee.`,
    inactive_user_suspense_message: `This punch is in suspense and has not been added to the timecard. At the time of this punch, {0} {1} was not an active employee. Select "Accept" to add this punch to {0} {1}'s timecard or select "Delete" to delete this punch.`,
    delete_punch_level_suspense_message: `This punch is in suspense and has not been added to the timecard. The punch level has been deleted. Select "Accept" to add this punch to {0} {1}'s timecard or select "Delete" to delete this punch. After accepting, please select a new punch level.`,
    invalid_paytype_suspense_message: `This punch is in suspense and has not been added to the timecard. The PayType is not valid. Select "Accept" to add this punch to {0} {1}'s timecard or select "Delete" to delete this punch. After accepting, please select a valid paytype.`,
    invalid_punch_hierarchy_suspense_message: `This punch is in suspense and has not been added to the timecard. Punch hierarchy is not allowed. Select "Accept" to add this punch to {0} {1}'s timecard or select "Delete" to delete this punch. After accepting, please select correct hierarchy.`,
    assigned_job_suspense_message: `This punch is in suspense and has not been added to the timecard. Punch is incorrect against assigning jobs. Select "Accept" to add this punch to {0} {1}'s timecard or select "Delete" to delete this punch. After accepting, please select a assigned job.`,
    empty_phase_suspense_message: `This punch is in suspense and has not been added to the timecard. Punch has not phase. Select "Accept" to add this punch to {0} {1}'s timecard or select "Delete" to delete this punch. After accepting, please select a phase.`,
    Punch_is_incorrect_against_assigning_jobs: "Punch is incorrect against assigning jobs.",
    This_punch_is_now_in_Suspense_and_can_be_found_in_the_Records_tab: "This punch is now in Suspense and can be found in the Records tab.",
    Employee_is_not_an_active_employee_This_punch_is_now_in_Suspense_and_can_be_found_in_the_Records_tab:
        "Employee is not an active employee. This punch is now in Suspense and can be found in the Records tab.",
    Use_Punch_Rules: "Use Punch Rules",
    Subscriptions_Selected: "{0} Subscriptions Selected",
    Enable_Punch_Detail_Edit: "Enable Punch Detail Edit",
    No_Time_Logged: "No Time Logged",
    Work_History: "Work History",
    Show_All_Employees_In_Payroll: "Show All Employees In Payroll",
    No_suspense_punch_found: "No suspense punch found",
    Suspense: "Suspense",
    Add_Missing_Punch: "Add Missing Punch",
    Accept_Suspense_Punch: "Accept Suspense Punch",
    NotAccepted: "NotAccepted",
    Accept_Suspense_Punches_Result: "Accept Suspense Punches Result",
    Failed_to_accept: "Failed to accept",
    Are_you_sure_you_want_to_accept_this_suspense_punch: "Are you sure you want to accept this suspense punch?",
    Are_you_sure_you_want_to_accept_the_selected_suspense_punches: "Are you sure you want to accept the selected suspense punches?",
    Are_you_sure_you_want_to_delete_reject_the_selected_suspense_punches: "Are you sure you want to delete/reject the selected suspense punches?",
    Deleted: "Deleted",
    Accepted: "Accepted",
    Are_you_sure_you_want_to_delete_this_suspense_punch: "Are you sure you want to delete this suspense punch?",
    Are_you_sure_you_want_to_reject_this_suspense_punch_time: "Are you sure you want to reject this suspense punch time?",
    Suspense_Punch: "Suspense Punch",
    Filter: "Filter",
    Suspense_Punches: "Suspense Punches",
    Edit_Suspense_Punch: "Edit Suspense Punch",
    Automatically_Add_Mobile_Suspense_Punch_to_Timecard: "Automatically Add Mobile Suspense Punch to Timecard",
    WorkingEmployeeTooltip: "Employees who are currently punched in. If the employee forgets\nto punch out the employee will be removed from the list after 24 hours.",
    ApproachingOvertimeTooltip:
        'Any employee whose Weekly "Regular" hours is from 32 hours to 40 hours\n(including hours being logged if employee is currently working).\nThis does not take into account California Overtime or Custom Overtime rules.',
    OvertimeTooltip:
        'Any employee whose Weekly "Regular" hours is 40 hours or above\n(including hours being logged if employee is currently working).\nThis does not take into account California Overtime or Custom Overtime rules.',
    Deleting_this_punch_will_delete_the_full_punch_set_Proceed: "Deleting this punch will delete the full punch set. Proceed?",
    Total_Employees: "Total Employee(s)",
    No_overtime_employee_found: "No overtime employee found",
    Hours_Until_OT: "Hours Until OT",
    Open_Active_Hours: "Open/Active Hours",
    No_approaching_overtime_employee_found: "No approaching overtime employee found",
    Approaching_Overtime: "Approaching Overtime",
    No_working_employee_found: "No working employee found",
    Scheduled_In: "Scheduled In",
    Scheduled_Out: "Scheduled Out",
    Current_Duration: "Current Duration",
    Working_Employees: "Working Employees",
    Approaching_OT: "Approaching OT",
    Working: "Working",
    Require_Phase: "Require Phase",
    Device_Connect_Status: "Device Connect Status",
    Hours_To_Trigger_Device_Connection_Exception: "Hours To Trigger Device Connection Exception",
    Are_you_sure_you_want_to_delete_this_question: "Are you sure you want to delete this question?",
    Add_Question: "Add Question",
    Edit_Question: "Edit Question",
    View_Question: "View Question",
    No_Question: "No Question",
    No_unapproved_timeoff_request_found: "No unapproved timeoff request found",
    Unapproved: "Unapproved",
    Timeoff_Request: "Timeoff Request",
    Custom_Rounded: "Custom Rounded",
    TwentyThreeMinute_Custom_Break_Rounding_Rule: "Custom Break Rounding Rule (<23 minutes)",
    Fifteen_Minute_Rounding_Rule: "15 Minute Rounding Rule",
    Enable_Custom_Break_Rounding_Rule: "Enable Custom Break Rounding Rule",
    Enable_Rate_Totals: "Enable Timecard Rate Totals",
    Enable_Timecard_Expenses: "Enable Timecard Expenses",
    Enable_Prior_Period_Adjustment: "Enable Prior Period Adjustment",
    Prior_Period_Adjustments: "Allow Prior Period Adjustment",
    Allow_Prior_Period_Adjustment_Exports: "Allow Prior Period Adjustment Export Edits",
    Enable_Timecard_Time_Expenses: "Enable Timecard Time Expenses",
    Show_Payroll_Rates: "Enable Show Payroll Rates",
    AutoSplitOnDayBoundry: "AutoSplitOnDayBoundry",
    ExportFailed: "ExportFailed",
    SkipExport: "SkipExport",
    TimecardSequenceError: "TimecardSequenceError",
    MobileLog: "MobileLog",
    Hide_Billing_Menu: "Hide Billing Menu",
    Errors: "Errors",
    Are_you_sure_you_want_to_remove_assigned_supervisor: "Are you sure you want to remove assigned supervisor?",
    Cannot_Recalculate_Timecard: "Cannot Recalculate Timecard",
    Punch_was_deleted_already: "Punch was deleted already",
    Network_Error: "Network Error",
    Please_check_your_internet_status: "Please check your internet status.",
    ExportToThirdParty_locked_warning: "Below employees are not ready to export now. please try again later.",
    Punches_are_set_export_on_next_connector_cycle: "Punches are set export on next connector cycle",
    By_closing_this_window_without_selecting_the_VIEW_TIMECARD_button_you_will_lose_your_changes:
        "By closing this window without selecting the VIEW TIMECARD button, you will lose your changes. Are you sure you want to close without saving?",
    Exception_was_reviewed_already: "Exception was reviewed already.",
    Punchset_is_not_exist: "Punchset is not exist. Please try again after refresh.",
    Cannot_approve_opened_punchset: "Cannot approve opened punchset.",
    TimecardSequence_locked_warning: "Employee locked by other actions now. Please try again later.",
    Cannot_Review_Location_Exception: "Cannot Review Location Exception",
    Cannot_Review_Biometric_Exception: "Cannot Review Biometric Exception",
    Cannot_UnApprove_Timecard: "Cannot UnApprove Timecard",
    Cannot_Approve_Timecard: "Cannot Approve Timecard",
    x_TimecardSequence_locked_warning: "{0} employee(s) locked by other actions now. Please try again later.",
    Timecard_sequence_locked_please_try_again_later: "Timecard sequence locked. please try again later.",
    Cannot_approve_own_punchset_as_supervisor: "Cannot approve own punchset as supervisor",
    Timecard_Report_Unlock_Warning: "If timecards are being modified when the report is being retrieved, this data may be included in the report. Please lock payroll to ensure data accuracy.",
    Cannot_export_payroll_for_unlocked_employee: "Cannot export payroll for unlocked employee",
    Retry: "Retry",
    Cannot_Lock_Payroll: "Cannot Lock Payroll",
    Change_In_Progress: "Change In Progress",
    Timecard_Dates: "Timecard Dates",
    Timecard_Details: "Show Timecard Details",
    Payroll_Time_Get_Warning:
        "This pay period contains {0} timecards that are currently being modified which may exclude those times. Note: While the pay period is unlocked, time data may be changing as the payroll data is fetched.",
    Payroll_Time_Lock_Warning:
        "This hierarchy contains {0} timecards that are currently being modified which may exclude those times. Payroll cannot be locked while these employees are being changed.",
    Generate: "Generate",
    Calculation_Date: "Calculation Date",
    View_Timecard: "View Timecard",
    Timecard_Punch_Drawer_Alert: "Filter to the punches that need to be edited by selecting the dates and times for the filter. Click VIEW TIMECARD button to generate the timecard.",
    Generating_timecard_please_wait: "Generating timecard, please wait",
    There_has_been_changes_made_to_the_punches_in_this_timecard_that_require_it_to_be_regenerated: "There has been changes made to the punches in this timecard that require it to be regenerated.",
    Click_the_Generate_timecard_above_to_view_the_timecard: "Click the Generate timecard above to view the timecard.",
    Timecard_Change_Already_In_Process: "Timecard Change Already In Process",
    Cannot_generate_timecard: "Cannot generate timecard. Another user or process is currently generating this timecard. Please try again later.",
    Generate_Timecard: "Generate Timecard",
    Add_Edit_Punches: "Add/Edit Punches",
    Loading_Timecards: "Loading Timecards",
    Authenticating: "Authenticating",
    Force_Employee_Account_Position: "Force Employee Account Position",
    If_a_punch_is_edited_with_a_new_item_the_associated_punch_in_the_punchset_will_be_adjusted_as_well:
        "If a punch is edited with a new item, the associated punch in the punchset will be adjusted as well.",
    No_changes_were_made: "No changes were made.",
    You_are_editing_x_punches_to_have_the_following_properties: "You are editing {0} punches to have the following properties:",
    Edit_Punches: "Edit Punches",
    Final_Review: "Final Review",
    Note_If_field_is_left_blank_that_property_will_not_be_updated: "Note: If field is left blank, that property will not be updated.",
    Group: "Group",
    Edit_x_Punches: "Edit {0} Punches",
    Edit_Selected_Punches: "Edit Selected Punches",
    Punch_Time: "Punch Time",
    No_punch_found: "No punch found",
    Apply_Filter: "Apply Filter",
    Invalid_time_range: "Invalid time range",
    Global_Punch_Edit_Drawer_Alert:
        'Filter to the punches that need to be edited by selecting the dates and times for the filter. Then, uncheck any punches that you would not want to be edited with your changes and click "Edit Selected Punches". The next step will be to specify what will be changed.',
    Filter_Punches: "Filter Punches",
    Global_Add_Confirmation: "Global Add Confirmation",
    Success: "Success",
    Punch_Data_Validation_Issues: "Punch Data Validation Issues",
    Execution_Results: "Execution Results",
    Global_Punch_Results: "Global Punch Results",
    This_action_will_add_the_specified_punch_criteria_for_the_Selected_Employees_Are_you_sure_that_you_want_to_continue:
        "This action will add the specified punch criteria for the Selected Employees. Are you sure that you want to continue?",
    Selected_Employees: "Selected Employees",
    One_or_more_of_the_selected_employees_do_not_have_permission_to_punch_to_this_hierarchy: "One or more of the selected employees do not have permission to punch to this hierarchy.",
    Global_Punch_Add: "Global Punch Add",
    Global_Punch_Edit: "Global Punch Edit",
    Punch_Rule_Override: "Punch Rule Override",
    Successfully_synced: "Successfully synced",
    Are_you_sure_you_want_to_force_mobile_sync_this_employee: "Are you sure you want to force mobile sync this employee?",
    Force_Mobile_Sync: "Force Mobile Sync",
    x_import_is_limited_to_x_rows: "{0} import is limited to {1} rows. This file has {2} rows. Please upload a file with less than {1} rows and try again.",
    Expense: "Expense",
    View_Employee_Expense: "View Employee Expense",
    Edit_Employee_Expense: "Edit Employee Expense",
    Add_Employee_Expense: "Add Employee Expense",
    Delete_Employee_Expense: "Delete Employee Expense",
    Approve_Employee_Expense: "Approve Employee Expense",
    View_Payroll_Expense: "View Payroll Expense",
    Lock_Payroll_Expense: "Lock Payroll Expense",
    Close_Payroll_Expense: "Close Payroll Expense",
    Export_Payroll_Expense: "Export Payroll Expense",
    Allowed_only_x_digit_decimal_point: "Allowed only {0} digit decimal point",
    Taxable_column_should_be_Yes_or_empty: 'Taxable column should be "Yes" or empty',
    Required_Columns: "Required Columns",
    Expected_CSV_File_Format: "Expected CSV File Format",
    Failed_to_import: "Failed to import",
    Import_Validation_Issues: "Import Validation Issues",
    Successfully_imported: "Successfully imported",
    Are_you_sure_you_want_to_import_punches_This_cannot_be_undone: "Are you sure you want to import {0} punches? This cannot be undone.",
    Are_you_sure_you_want_to_import_expense_time_This_cannot_be_undone: "Are you sure you want to import {0} expense times? This cannot be undone.",
    Are_you_sure_you_want_to_import_expense_amount_This_cannot_be_undone: "Are you sure you want to import {0} expense amounts? This cannot be undone.",
    Import_Type: "Import Type",
    Expense_Time_Data: "Expense Time Data",
    Expense_Amount_Data: "Expense Amount Data",
    Punch_Data: "Punch Data",
    ImportCSV: "Import CSV file",
    Are_you_sure_you_want_to_change_this_account_setting: "Are you sure you want to change this account setting?",
    Are_you_sure_you_want_to_change_this_setting_of_hierarchy: "Are you sure you want to change this setting of hierarchy?",
    Are_you_sure_you_want_to_delete_this_custom_report: "Are you sure you want to delete this custom report?",
    Compile: "Compile",
    Default_File_Name: "Default File Name",
    File_Extension: "File Extension",
    PayrollTimeExport: "Payroll Time Export",
    PayrollExpenseExport: "Payroll Expense Export",
    TimecardPunchDetailReport: "Timecard Punch Detail Report",
    TimecardEstimatedTimeReport: "Timecard Estimated Time Report",
    TimecardInOutReport: "Timecard In/Out Report",
    There_is_no_Custom_Report: "There is no Custom Report",
    Add_Custom_Report: "Add Custom Report/Script",
    Edit_Custom_Report: "Edit Custom Report/Script",
    Custom_Report_Type: "Custom Report Type",
    Custom_Report: "Custom Reports/Scripts",
    Are_you_sure_you_want_to_calculate_punch_rules: "Are you sure you want to calculate punch rules",
    Calculate: "Calculate",
    Pending_Punch_Rules_Calculation: "Pending Punch Rules Calculation",
    Enable_Punch_Rule: "Enable Punch Rule",
    Single_Day: "Single Day",
    Multi_Day: "Multi Day",
    Punch_Day_Grouping: "Punch Day Grouping",
    Punch_Rule_Type: "Punch Rule Type",
    Auto_Approve_Punchsets: "Auto Approve Punchsets",
    Submit: "Submit",
    Account_User_Settings: "Account User Settings",
    Is_Account_User: "Is Account User",
    not_allowed_to_recalculate_for_locked_period: "not allowed to recalculate for locked period",
    Hide_On_Mobile: "Hide On Mobile",
    Use_Date_Filter: "Use Date Filter",
    Job_ID: "Job ID",
    Client_ID: "Client ID",
    Duplicated_Job_exist: "Duplicated Job exist",
    Allowed_Jobs: "Allowed Jobs",
    Limit_Device_Jobs: "Limit Device Jobs",
    after_x_mins: "after {0} mins",
    Time_Window: "Time Window",
    Time_Duration: "Time Duration",
    Mobile_Breaks: "Mobile Breaks",
    There_is_no_Mobile_Break_item: "There is no Mobile Break item",
    Are_you_sure_you_want_to_delete_the_selected_mobile_break: "Are you sure you want to delete the selected mobile break?",
    failed_to_set_export: "failed to set export",
    Edit_Phase: "Edit Phase",
    Choose_Date_Range: "Choose Date Range",
    Exports_any_third_party_punches_that_were_not_successfully_uploaded: "Exports any third party punches that were not successfully uploaded.",
    Download_Expenses_Report: "Download Expenses Report",
    Invalid_Payroll: "Invalid Payroll",
    The_employee_payroll_level_is_not_valid_please_update_payroll_level: "The employee payroll level is not valid. Please update payroll level",
    Add_Phase: "Add Phase",
    max_x_chars: "max {0} chars",
    Phase_Selected: "Phase Selected",
    x_Phases_Selected: "{0} Phases Selected",
    Are_you_sure_you_want_to_delete_the_selected_phase: "Are you sure you want to delete the selected phase(s)?",
    Filter_By_Default_Hierarchy: "Filter By Default Hierarchy",
    Filter_By_Timecard_Validation_Messages: "Filter By Timecard Validation Messages",
    Exception_Confirm_Screen_is_not_valid: "Exception Confirm Screen is not valid",
    Exception_Confirm_Screen: "Exception Confirm Screen",
    Paytypes_that_contribute_to_overtime_cannot_be_used: "Paytypes that contribute to overtime cannot be used.",
    Enter_Hours: "Enter Hours",
    Time_Entry: "Time Entry",
    Private_Note: "Private Note",
    Enable_Policy_For_Account: "Enable Policy For Account",
    Button_Label: "Button Label",
    Button_Label_langX: "Button Label ({0})",
    X_Questions: "{0} Questions",
    Some_questions_are_missing_information_for_the_selected_languages: "Some questions are missing information for the selected languages.",
    PunchOut_introduction_is_not_valid: "PunchOut introduction is not valid",
    PunchIn_introduction_is_not_valid: "PunchIn introduction is not valid",
    Empty_question: "Empty question",
    Use_Punch_Question: "Use Punch Question",
    Are_you_sure_you_want_to_post_punch_question: "Are you sure you want to post this punch question?",
    Order: "Order",
    Exception_Response: "Exception Response",
    Prevent_Punch_Exception: "Prevent Punch w/Exception",
    Modified_Date: "Modified Date",
    Prevent_punch_and_notify_user_if_response_creates_an_exception: "Prevent punch and notify user if response creates an exception",
    Create_an_Exception_when_response_is: "Create an Exception when response is",
    Button2: "Button #2",
    Button1: "Button #1",
    Button_Labels: "Button Labels",
    Question: "Question",
    Title_langX: "Title ({0})",
    New_Punch_IN_Question: "New Punch IN Question",
    Edit_Punch_IN_Question: "Edit Punch IN Question",
    New_Punch_OUT_Question: "New Punch OUT Question",
    Edit_Punch_OUT_Question: "Edit Punch OUT Question",
    No_Punch_IN_Questions: "No Punch IN Questions",
    No_Punch_OUT_Questions: "No Punch OUT Questions",
    Punch_In_Questions: "Punch IN Questions",
    Punch_Out_Questions: "Punch OUT Questions",
    Are_you_sure_you_want_to_remove_x_language: "Are you sure you want to remove {0}?",
    Cannot_remove_default_language_Eng: "Cannot remove default language Eng",
    Introduction_message: "Introduction message",
    Introduction_message_Language_x: "Introduction message ({0})",
    Include_introduction_page_message_Punch_In: "Include introduction page message (Punch IN)",
    Include_introduction_page_message_Punch_Out: "Include introduction page message (Punch OUT)",
    Select_Language: "Select Language",
    Languages: "Languages",
    Punch_Questions: "Punch Questions",
    Enable_Punch_Questions: "Enable Punch Questions",
    Hours_Per_Day_cannot_greather_than_x: "Hours Per Day cannot greather than {0}",
    This_punch_is_not_valid: "This punch is not valid",
    Are_you_sure_you_want_to_recalculate_this_employee_timecard: "Are you sure you want to recalculate this employee timecard?",
    successfully_recalculated: "successfully recalculated",
    Recalculate: "Recalculate",
    CompileErrors: "Compile Errors",
    Enable_Payroll_Lambda: "Enable Payroll Lambda",
    Disable_Accrual_Calculation_For_Payroll: "Disable Accrual Calculation",
    Are_you_sure_you_want_to_calculate_payroll: "Are you sure you want to calculate payroll?",
    Calculate_Payroll: "Calculate Payroll",
    Cannot_make_for_existing_date: "Cannot make for existing date",
    Work_Day: "Work Day",
    Enable_Expenses: "Enable Expenses",
    Time_Data: "Time Data",
    Expenses_Data: "Expenses Data",
    Total_Paid: "Total Paid",
    Total_Deducted: "Total Deducted",
    Time_Summary: "Time Summary",
    Expenses_Summary: "Expenses Summary",
    All_IP_Address_approved: "All IP Address approved",
    Approved_IP_Addresses: "Approved IP Addresses",
    PayType_Removed: "PayType Removed",
    Calculation_Day_cannot_fall_in_locked_period: "Calculation Day cannot fall in locked period",
    Cannot_change_the_calculation_day_grouping_for_special_punch_set: "Cannot change the calculation day grouping for special punch set",
    Failed_to_update_punch_time_for_max_length: "Failed to update punch time for max punchset length",
    Enable_Calculation_Day_Group: "Enable Calculation Day Group",
    PUNCH_IN_DATE: "PUNCH IN DATE",
    Select_a_date: "Select a date",
    Shift_Note: "Shift Note",
    loading: "loading...",
    No_scheduled: "No conflicting schedule",
    Are_you_sure_you_want_to_turn_on_HR: "Are you sure you want to turn on HR? This will migrate the account and can take a few minutes.",
    Are_you_sure_you_want_to_delete_employee: "Are you sure you want to delete employee(s)",
    Are_you_sure_you_want_to_unassign_employee: "Are you sure you want to unassign the selected employee(s)?",
    Deleting_or_Inactivating_an_employee_will_remove_all_future_holiday: "Deleting or Inactivating an employee will remove all future holiday. Proceed?",
    Deleting_or_Inactivating_an_employee_will_remove_all_future_holiday_leave: "Deleting or Inactivating an employee will remove all future holiday and leave. Proceed?",
    Job_is_not_allowed_for_this_hierarchy: "Job is not allowed for this hierarchy.",
    Yes: "Yes",
    Are_you_sure_you_want_to_delete_the_selected_punch_rule: "Are you sure you want to delete the selected punch rule?",
    Type_script_code: "Type script code...",
    Scheduled_job: "Scheduled Job",
    CronExpression: "Cron",
    System: "System",
    No_scheduled_jobs: "No scheduled jobs",
    There_is_no_Punch_Rule_item: "There is no Punch Rule item",
    Punch_Rules: "Punch Rules",
    HR_was_successfully_created: "HR was successfully created",
    Enable_HR: "Enable HR",
    Client_Id_is_duplicated: "Client Id is duplicated",
    Include_Plan_Shifts: "Include Plan Shifts",
    Custom_Pay_Class: "Custom Pay Class",
    Pay_Class: "Pay Class",
    Job_Position: "Job Position",
    Client_Position: "Client Position",
    Account_Position_Definition: "Account Position Definition",
    Create_new: "Create new",
    Usable_Positions: "Usable Positions",
    Singular_Position_Label: "Singular Position Label",
    Plural_Position_Label: "Plural Position Label",
    Singular_Job_Label: "Singular Job Label",
    Plural_Job_Label: "Plural Job Label",
    Singular_Phase_Label: "Singular Phase Label",
    Plural_Phase_Label: "Plural Phase Label",
    Are_you_sure_you_want_to_delete_scheduled_job: "Are you sure you want to delete '{0}' scheduled job?",
    Are_you_sure_you_want_to_delete_selected_PayClasses: "Are you sure you want to delete selected PayClasses?",
    Are_you_sure_you_want_to_run_scheduled_job: "Are you sure you want to run the '{0}' scheduled job? This cannot be stopped once started.",
    Default_PayClass: "Default PayClass",
    No_PayClass_found: "No PayClass found",
    Burden: "Burden",
    Add_Pay_Class: "Add Pay Class",
    Edit_Pay_Class: "Edit Pay Class",
    Use_Pay_Classes: "Use Pay Classes",
    Tasks: "Tasks",
    Enable_PayClass: "Enable PayClass",
    Enable_Use_Base_Pay_Rate_In_PayClass: "Enable Use Base Pay Rate In PayClass",
    Punched_In: "Punched In",
    Punched_Out: "Punched Out",
    Home_Job: "Home Job",
    Select_Client: "Select Client",
    Last_Modified: "Last Modified",
    Position_Field: "Position Field",
    successfully_approved: "successfully approved",
    successfully_unapproved: "successfully unapproved",
    Cannot_approve_unapprove_the_approved_expense_by_supervisor: "Cannot approve/unapprove the approved expense(s) by supervisor",
    Cannot_approve_the_approved_expense: "Cannot approve the approved expense(s)",
    Cannot_unapprove_the_unapproved_expense: "Cannot unapprove the unapproved expense(s)",
    Are_you_sure_you_want_to_approve_the_selected_expense: "Are you sure you want to approve the selected expense(s)?",
    Are_you_sure_you_want_to_unapprove_the_selected_expense: "Are you sure you want to unapprove the selected expense(s)?",
    No_timecard_found: "No timecard found!",
    Employee_default_poisition_is_not_valid: "Employee default poisition is not valid. Please check it before add punch",
    Employee_default_position_is_not_valid_Are_you_want_punch: "Employee default position is not valid. Are you sure you want to punch without position?",
    Are_you_sure_you_want_to_delete_the_selected_job: "Are you sure you want to delete the selected job(s)?",
    Job_Selected: "1 Job Selected",
    x_Job_Selected: "{0} Jobs Selected",
    Are_you_sure_you_want_to_delete_selected_expense: "Are you sure you want to delete selected expense(s)?",
    Are_you_sure_you_want_to_delete_this_expense: "Are you sure you want to delete this expense?",
    Delete_Expense: "Delete Expense",
    Are_you_sure_you_want_to_remove_logo: "Are you sure you want to remove logo?",
    Non_Taxable: "Non-Taxable",
    No_expense_found: "No expense found!",
    Expense_Selected: "1 Expense Selected",
    x_Expenses_Selected: "{0} Expenses Selected",
    Receipt: "Receipt",
    New_Expense: "New Expense",
    Edit_Expense: "Edit Expense",
    Amount: "Amount ($)",
    Expense_Date: "Expense Date",
    Taxable: "Taxable",
    Employee_Approved: "Employee Approved",
    Supervisor_Approved: "Supervisor Approved",
    Drag_and_Drop_or_click_to_choose_a_file: "Drag and Drop or click to choose a file",
    Are_you_sure_want_to_remove_the_uploaded_file: "Are you sure want to remove the uploaded file?",
    You_cant_choose_yourself_as_your_supervisor: "You can't choose yourself as your supervisor",
    No_Supervisor: "No Supervisor",
    Will_this_user_need_to_track_time: "Will this user need to track time?",
    Add_Account_User: "Add Account User",
    Edit_Account_User: "Edit Account User",
    Group_By_Supervisor: "Group By Supervisor",
    Show_Direct_Reports_Only: "Show Direct Reports Only",
    No_employee_found: "No employee found!",
    Select_Supervisor: "Select Supervisor",
    Non_Direct_Report: "Non-Direct Report",
    View_All_Employees: "View All Employees",
    Enable_Supervisor_Direct_Report: "Enable Supervisor Direct Report",
    Allow_Self_Emp_Edit: "Allow Self Emp Edit",
    Self_Service: "Self Service",
    System_Approved: "System Approved",
    No_Records: "No Records",
    Yes_I_am_sure_this_is_name: "Yes I'm sure this is {0}",
    Score: "Score",
    Secondary_Score: "Secondary Score",
    NO_or_UNSURE: "NO or UNSURE",
    Is_this_firstName_lastName: "Is this {0} {1}?",
    Enable_PunchSet_Exception_Filter: "Enable PunchSet Exception Filter",
    Cannot_approve_the_locked_punchset: "Cannot approve the locked punchset",
    PunchSet_approved_successfully: "PunchSet approved successfully",
    PunchSet_unapproved_successfully: "PunchSet unapproved successfully",
    Failed_to_approve_PunchSet: "Failed to approve PunchSet",
    Failed_to_unapprove_PunchSet: "Failed to unapprove PunchSet",
    Approve_PunchSet: "Approve PunchSet",
    Are_you_sure_you_want_to_approve_the_punchset: "Are you sure you want to approve the punchset?",
    In_Img: "In Img",
    In_Map: "In Map",
    Out_Img: "Out Img",
    Out_Map: "Out Map",
    In_Bio: "In Bio",
    Out_Bio: "Out Bio",
    Miss: "Miss",
    Bio: "Bio",
    Loc: "Loc",
    E_App: "E.App",
    S_App: "S.App",
    Punch_In_Time: "Punch In Time",
    Punch_Out_Time: "Punch Out Time",
    Sup_Approved: "S.Approved",
    Exceptions: "Exceptions",
    No_Exception_found: "No Exception found!",
    Show_Reviewed: "Show Reviewed",
    Boundary: "Boundary",
    Low_Score: "Low Score",
    Supervisor: "Supervisor",
    Validation_msgs: "Validation msg(s)",
    Reviewed_by: "Reviewed by",
    Mark_As_Read: "Mark As Read",
    Approval: "Approval",
    Punches: "Punches",
    Hierarchy_name_is_duplicated: "Hierarchy name is duplicated",
    This_field_requires_a_number_between_min_and_max: "This field requires a number between {0} and {1}",
    Applied_Hours: "Applied Hrs",
    Applied: "Applied",
    This_hierarchy_is_not_registered_for_your_IP: "This hierarchy is not registered for your IP address.",
    Your_password_has_been_updated: "Your password has been updated.",
    Please_enter_your_new_password: "Please enter your new password",
    Set_New_Password: "Set New Password",
    If_theres_Findd_account_linked_to_this_email_address: "If there's an account linked to this email address, we'll send over instructions to reset your password.",
    Back_to_sign_in: "Back to sign in",
    Request_Reset_Link: "Request Reset Link",
    Enter_your_email_address: "Enter your email address below and we'll get you back on track.",
    Forgot_your_password: "Forgot your password?",
    Forgot_password: "Forgot password?",
    Are_you_sure_you_want_to_close_payroll_hierarchies_before_lock:
        "Are you sure you want to close {0} payroll hierarchies? Closing payroll will lock the unlocked payroll hierarchies for this pay period.",
    Are_you_sure_you_want_to_close_payroll_hierarchy_before_lock: "Are you sure you want to close payroll hierarchy? Closing payroll will lock the unlocked payroll hierarchy for this pay period.",
    Are_you_sure_you_want_to_close_payroll_hierarchies: "Are you sure you want to close {0} payroll hierarchies?",
    Are_you_sure_you_want_to_close_payroll_hierarchy: "Are you sure you want to close payroll hierarchy?",
    Cannot_delete_leave_request_applied_in_payroll: "Cannot delete leave request(s) applied in payroll",
    Applied_Payroll: "Applied Payroll",
    Are_you_sure_you_want_to_change_this_value_as_Global_Admin: "Are you sure you want to change this value as Global Admin",
    Cannot_update_Leave_Request_for_locked_pay_period: "Cannot update Leave Request for locked pay period",
    Cannot_update_Locked_Leave_Request: "Cannot update Locked Leave Request",
    Cannot_make_Locked_Leave_Request: "Cannot make Locked Leave Request",
    Cannot_make_Leave_Request_for_locked_pay_period: "Cannot make Leave Request for locked pay period",
    Cannot_delete_Accrual_used_for_Employee_Accrual: "Cannot delete Accrual used for Employee Accrual.",
    Cannot_delete_Accrual_which_is_referred_in_Leave_Request: "Cannot delete Accrual which is referred in Leave Request.",
    Cannot_add_Leave_Request_for_Inactive_Employee: "Cannot Submit Leave Request for Inactive Employee.",
    Name_requires_maximum_chars: "Name requires maximum {0} chars",
    ACCEPT: "ACCEPT",
    Account: "Account",
    Account_Admin: "Account Admin",
    Account_Billing_Details: "Account Billing Details",
    Account_Default_Timezone: "Account Default Timezone",
    Account_Hierarchy_Level_Definitions: "Account Hierarchy Level Definitions",
    Account_Position: "Account Position",
    Account_Positions: "{0} Account Positions",
    Account_Positions_Table_Header: "Account Positions",
    Account_Settings: "Account Settings",
    Account_User: "Account User",
    Account_User_removed_successfully: "Account User removed successfully!",
    Account_Users: "Account Users",
    Account_Users_removed_successfully: "Account Users removed successfully!",
    Accruals: "Accruals",
    Action: "Action",
    Contract: "Contract",
    Activation_Date: "Activation Date",
    Activation_Time: "Activation Time",
    Active: "Active",
    ACTIVE_EMPLOYEES: "ACTIVE EMPLOYEES",
    ActiveUsers: "Active Users",
    Activity: "Activity",
    Add: "Add",
    Add_Account_Role_Type: "Add Account Role Type",
    Add_All_Devices: "Add All Devices",
    Add_Another: "Add Another",
    Add_Auto_Break: "Add Auto Break",
    Add_Device: "Add Device",
    ADD_EMPLOYEE: "Add Employee",
    Add_Employees: "Add Employees",
    Add_Equipment: "Add Equipment",
    ADD_EQUIPMENT: "ADD EQUIPMENT",
    Add_Hierarchy_Definition: "There isn't any hierarchy level definition. Please add a hierarchy level definition.",
    Add_Hierarchy_Devices: "Add Hierarchy Devices",
    ADD_LOCATION: "ADD LOCATION",
    ADD_MICRO_LOCATION: "ADD MICRO LOCATION",
    Add_Punch: "Add Punch",
    Add_Employee_Devices: "Add Employee Devices",
    AddHierarchyDefinition: "Add Hierarchy Level",
    AddHierarchyItemHintText: "Add New Hierarchy Level",
    AddHierarchyItemMessage: "Add new {0} to {1}",
    AddItem: "ADD ITEM",
    AddNewPosition: "Add New Position",
    AddNewPositionDefinition: "Add New Position Definition",
    AddPosition: "Add Position",
    Address: "Address",
    Admin_Approvals: "Admin Approvals",
    All: "All",
    All_employees_will_have_the_account_as_payroll_hierarchy: "All employees will have the account as payroll hierarchy. Do you want it?",
    All_Exceptions: "All Exceptions",
    All_Permissions: "All Permissions",
    All_Records: "All Records",
    Self_Service_Login: "Self Service Login",
    AllowAccessToLevels: "Allow access to other levels (View Full Hierarchy)",
    AllTimecards: "All Timecards",
    Apartment_suite: "Apartment, suite, unit, floor, etc.",
    Approve: "Approve",
    Approve_All: "Approve All",
    Approve_all_timecards: "Approve all timecards (count {0})",
    Approve_Timecard: "Approve Timecard",
    Approve_Timecards: "Approve Timecards",
    Approve_timecards_on_this_page: "Approve timecards on this page (count {0})",
    Approve_Week: "Approve Week",
    Approved: "Approved",
    Approved_Week: "Approved Week",
    ApproveSelectedTimecards: "Approve Selected Timecards?",
    Are_you_sure_delete_device: "Are you sure you want to delete this 'Device'?",
    Are_you_sure_delete_devices: "Are you sure you want to delete the selected 'Devices'?",
    Are_you_sure_delete_face_spaces: "Are you sure you want to delete the selected 'Face Space(s)'?",
    Are_you_sure_delete_Hierarchies: "Are you sure you want to delete the selected Hierarchies?",
    Are_you_sure_delete_Hierarchy: "Are you sure you want to delete this Hierarchy?",
    Are_you_sure_delete_Micro_Location: "Are you sure you want to delete this 'Micro Location'?",
    Are_you_sure_delete_Micro_Locations: "Are you sure you want to delete the selected 'Micro Locations'?",
    Are_you_sure_delete_pay_group: "Are you sure you want to delete this PayGroup?",
    Are_you_sure_delete_pay_type: "Are you sure you want to delete this PayType?",
    Are_you_sure_delete_Punch: "Are you sure you want to delete this punch?",
    Are_you_sure_replace_profile_image: "Are you sure you want to remove the current user profile image and use this one instead?",
    Are_you_sure_want_to_remove_hierarchy: "Are you sure you want to remove selected Hierarchy? All children of this item will also be removed.",
    Are_you_sure_you_want_to_delete_selected_Role: "Are you sure you want to delete selected Role?",
    Are_you_sure_you_want_to_delete_selected_User: "Are you sure you want to delete selected User?",
    Are_you_sure_you_want_to_delete_selected_Users: "Are you sure you want to delete selected Users?",
    Are_you_sure_you_want_to_export_payroll_for_the_selected_employee: "Are you sure you want to export payroll for the selected employee?",
    Are_you_sure_you_want_to_export_payroll_for_the_selected_employees: "Are you sure you want to export payroll for the {0} selected employees?",
    Are_you_sure_you_want_to_export_payroll_for_the_X_selected_employees_as_shown_below: "Are you sure you want to export payroll for the {0} selected employee(s) as shown below?",
    Are_you_sure_you_want_to_lock_payroll_hierarchies: "Are you sure you want to lock {0} payroll hierarchies?",
    Are_you_sure_you_want_to_lock_payroll_hierarchies_unapproved_timecard: "Are you sure you want to lock {0} payroll hierarchies that have unapproved timecards?",
    Are_you_sure_you_want_to_lock_payroll_hierarchies_unapproved_timecard_with_expense:
        "Are you sure you want to lock {0} payroll hierarchies that have unapproved timecards? It will lock expense too.",
    Are_you_sure_you_want_to_lock_payroll_hierarchies_unapproved_expenses: "Are you sure you want to lock {0} payroll hierarchies that have unapproved expenses?",
    Are_you_sure_you_want_to_lock_payroll_hierarchies_unapproved_expenses_with_timecard:
        "Are you sure you want to lock {0} payroll hierarchies that have unapproved expenses? It will lock timecard too.",
    Are_you_sure_you_want_to_lock_payroll_hierarchy: "Are you sure you want to lock payroll hierarchy?",
    Are_you_sure_you_want_to_lock_payroll_hierarchy_unapproved_timecard: "Are you sure you want to lock a payroll hierarchy that has unapproved timecards?",
    Are_you_sure_you_want_to_lock_payroll_hierarchy_unapproved_timecard_with_expense: "Are you sure you want to lock a payroll hierarchy that has unapproved timecards? It will lock expense too.",
    Are_you_sure_you_want_to_lock_payroll_hierarchy_unapproved_expenses: "Are you sure you want to lock a payroll hierarchy that has unapproved expenses?",
    Are_you_sure_you_want_to_lock_payroll_hierarchy_unapproved_expenses_with_timecard: "Are you sure you want to lock a payroll hierarchy that has unapproved expenses? It will lock timecard too.",
    Are_you_sure_you_want_to_unapprove_timecard: "Are you sure you want to unapprove timecard?",
    Are_you_sure_you_want_to_unlock_payroll_hierarchies: "Are you sure you want to unlock {0} payroll hierarchies?",
    Are_you_sure_you_want_to_unlock_payroll_hierarchy: "Are you sure you want to unlock payroll hierarchy?",
    Audit: "Audit",
    Audits: "Audits",
    Auto_Break: "Auto Break",
    AutoBreaks: "Auto Breaks",
    AutoTransfer: "Auto Transfer",
    Beacon_Registration_Code: "Beacon Registration Code",
    Bi_Weekly: "Bi Weekly",
    Bill_Rate: "Bill Rate",
    Billing: "Billing",
    Biometric: "Biometric",
    Biometric_Exception: "Biometric Exception",
    Biometric_Punch_Exception_Face_not_found: "Biometric Punch Exception. Face not found.",
    Biometric_Punch_Exception_Match_below_threshold: "Biometric Punch Exception. Match below threshold.",
    Biometric_Score: "Biometric Score",
    Biometric_Threshold: "Biometric Threshold",
    Break_Duration: "Break Duration",
    By_changing_the_payroll_hierarchy_definition:
        "By changing the payroll hierarchy definition to '{0}', it will require all employee's payroll hierarchy to be automatically assigned. Please confirm this action.",
    California_Overtime: "California Overtime",
    Cancel: "Cancel",
    CANCEL: "CANCEL",
    Cannot_add_device_to_account_level: "Cannot add device to account level. Please select child hierarchy",
    Cannot_add_missing_punch_for_removed_hierarchy: "Cannot add missing punch. The hierarchy item has been removed.",
    Cannot_add_missing_punch_for_removed_position: "Cannot add missing punch. The position has been removed.",
    The_position_has_been_removed_Are_you_want_punch: "The position has been removed. Are you sure you want to punch without position?",
    Cannot_approve_the_locked_timecard: "Cannot approve the locked timecard",
    Cannot_Change_Pay_Calendar: "Cannot Change Pay Calendar",
    Cannot_Change_Pay_Calendar_Contact_Findd:
        "Cannot change the PayCalendar because this paygroup has already been attached to at least one employee punchsets. Please contact support for assistance.",
    Cannot_Change_Pay_Calendar_Setting: "Cannot Change Pay Calendar Setting",
    Cannot_Change_Pay_Calendar_Setting_Contact_Findd:
        "Cannot change the PayCalendarSetting because this paygroup has already been attached to at least one employee punchsets. Please contact support for assistance.",
    Cannot_Change_Pay_Period_Start_Day: "Cannot Change Pay Period Start Day",
    Cannot_Change_Pay_Period_Start_Day_Contact_Findd:
        "Cannot change the PayPeriodStartDay because this paygroup has already been attached to at least one employee punchsets. Please contact support for assistance.",
    Cannot_delete_Account_Admin_user: "Cannot delete AccountAdmin user.",
    Cannot_Delete_Hierarchy: "Cannot Delete Hierarchy",
    Cannot_Delete_Hierarchy_because_it_is_already_use: "Cannot delete hierarchy and children because there is at least one hierarchy already in use.",
    Cannot_delete_positions_title: "Cannot Delete Position(s)",
    Cannot_Delete_User: "Cannot Delete User",
    Cannot_Export_Payroll_For_Selected_Employee: "Cannot Export Payroll For The Selected Employee",
    Cannot_export_payroll_for_selected_employee_Add_missing_punches: "Cannot export payroll for the selected employee. Add missing punches before export.",
    Cannot_Export_Payroll_For_Selected_Employees: "Cannot Export Payroll For The Selected Employees",
    Cannot_export_payroll_for_selected_employees_Add_missing_punches: "Cannot export payroll for the selected employees. Add missing punches before export.",
    Cannot_find_a_valid_address: "Cannot find a valid address!",
    Cannot_Lock_Payroll_Hierarchy: "Cannot Lock Payroll Hierarchy",
    Cannot_lock_selected_Payroll_Hierarchy_because_Missing_punch_exist: "Cannot lock selected Payroll Hierarchy, because Missing punch exist.",
    Cannot_lock_selected_Payroll_Hierarchy_because_supervisor_unapproved_punchset_exist: "Cannot lock selected Payroll Hierarchy, because supervisor unapproved punchset exist.",
    Cannot_lock_selected_Payroll_Hierarchy_because_employee_unapproved_punchset_exist: "Cannot lock selected Payroll Hierarchy, because employee unapproved punchset exist.",
    Cannot_lock_selected_Payroll_Hierarchy_because_supervisor_unapproved_expenses_exist: "Cannot lock selected Payroll Hierarchy, because supervisor unapproved expenses exist.",
    Cannot_lock_selected_Payroll_Hierarchy_because_employee_unapproved_expenses_exist: "Cannot lock selected Payroll Hierarchy, because employee unapproved expenses exist.",
    Cannot_this_UserRole: "Cannot delete this UserRole, because it is assigned to AccountUser",
    Cannot_unapprove_the_locked_timecard: "Cannot unapprove the locked timecard",
    Cannot_approve_the_timecard_which_has_opened_punchset: "Cannot approve the timecard(s) which has opened punchset",
    CannotApproveTimecardsTitle: "Cannot Approve Timecard(s)",
    CannotExportTimecardsBody: "Cannot export payroll file. One or more timecards require approval before timecards can be exported to payroll.",
    CannotExportTimecardsTitle: "Cannot Export To Payroll",
    CannotFindActivationCode: "Activation Code not found",
    Cant_create_employee_with_root_level: "You cannot create a employee with root level as default.",
    Cant_delete_positions: "The following position(s) cannot be deleted. Position(s) assigned to either hierarchy item, employee or schedule: {0}",
    Change_Date: "Change Date",
    Change_Employee_Payroll: "Change Employee Payroll",
    Change_Pay_Calendar: "Change Pay Calendar",
    Change_Pay_Calendar_as_GlobalAdmin: "This paygroup has already been attached to employee punchsets. Are you sure you would like to change the PayCalendar as Global Admin?",
    Change_Pay_Calendar_Setting: "Change Pay Calendar Setting",
    Change_Pay_Calendar_Setting_as_GlobalAdmin: "This paygroup has already been attached to employee punchsets. Are you sure you would like to change the PayCalendarSetting as Global Admin?",
    Change_Pay_Period_Start_Day: "Change Pay Period Start Day",
    Change_Pay_Period_Start_Day_as_GlobalAdmin: "This paygroup has already been attached to employee punchsets. Are you sure you would like to change the PayPeriodStartDay as Global Admin?",
    Change_payroll_definition_as_GlobalAdmin: "Are you sure you would like to change the hierarchy payroll definition as Global Admin?",
    Change_payroll_as_GlobalAdmin: "New Payroll pay settings are different or pay type problem exist. Are you sure you would like to change it as Global Admin?",
    Children: "Children",
    Choose_Approve_All_Timecard_Option: "Choose Approve All Timecard Option",
    Choose_Employee: "Choose Employee",
    Choose_Equipment: "Choose Equipment",
    CHOOSE_HIERARCHY_ITEM: "CHOOSE HIERARCHY ITEM",
    Choose_Unapprove_All_Timecard_Option: "Choose Unapprove All Timecard Option",
    ChooseLocationHierarchy: "Location Level",
    ChoosePunchHierarchy: "Punch Level",
    City: "City",
    click_to_view_x_records: "Click to view {0} records.",
    Clock_Mode: "Clock Mode",
    Clock_PIN: "Clock PIN",
    Clock_PIN_must_be_unique: "Clock PIN must be unique",
    Close: "Close",
    confirm_approve_all_biometric_exceptions: "Are you sure you want to approve all biometric exceptions in this page?",
    confirm_approve_all_location_exceptions: "Are you sure you want to approve all location exceptions in this page?",
    Confirm_delete_equipment: "Are you sure you want to delete the selected 'Equipment'?",
    Confirm_delete_client: "Are you sure you want to delete the selected 'Client(s)'?",
    Confirm_Dialog: "Confirm Dialog",
    confirm_reject_all_biometric_exceptions: "Are you sure you want to reject all biometric exceptions in this page?",
    confirm_reject_all_location_exceptions: "Are you sure you want to reject all location exceptions in this page?",
    Are_you_sure_you_want_to_approve_the_timecard: "Are you sure you want to approve the timecard?",
    CONFIRMED_IMAGES_OF_x: "Confirmed images of {0}",
    ConfirmUnlockTimecard: "Are you sure you would like to unlock this timecard? This action will require re-approval before timecard can be exported to payroll.",
    Compose_New_message: "Compose New Message",
    COPY: "Copy",
    COPY_OF: "Copy Of",
    Cost_Center_cannot_be_longer_than: "Cost Center cannot be longer than 10 characters.",
    Cost_Center_should_not_consist_of_white_spaces: "Cost Center should not consist of white spaces",
    CostCenter: "Cost Center",
    CostCenterCode: "Cost Center Code",
    Country: "Country",
    Credit_Accrual: "Contribute to Accrual",
    Currency: "Currency",
    Current_Hierarchy: "Current Hierarchy",
    Punch_Detail_Report: "Punch Detail Report",
    Dashboard: "Dashboard",
    DASHBOARD: "DASHBOARD",
    Date: "Date",
    Date_Format: "Date Format",
    Date_Time: "Date/Time",
    Default_Geofence_Perimeter: "Default Geofence Perimeter",
    Default_Hierarchy: "Default Hierarchy",
    Default_hierarchy_changed: 'Default hierarchy changed to "{0}", would you like to change the payroll hierarchy to "{1}" as well?',
    Default_Microlocation_Perimeter: "Default Microlocation Perimeter",
    Default_Pay_Type: "Default Pay Type",
    DefaultPosition: "Default Position",
    Delete: "Delete",
    DELETE: "DELETE",
    Delete_All_Devices: "Delete All Devices",
    Delete_Auto_Break: "Delete Auto Break",
    Delete_Device: "Delete Device",
    DELETE_EMPLOYEE: "DELETE EMPLOYEE",
    Delete_Employees: "Delete Employees",
    DELETE_EMPLOYEES: "DELETE EMPLOYEES",
    Delete_Equipment: "Delete Equipment",
    DELETE_EQUIPMENT: "DELETE    EQUIPMENT",
    Delete_Client: "Delete Client",
    DELETE_HIERARCHIES: "DELETE HIERARCHIES",
    DELETE_HIERARCHY: "DELETE HIERARCHY",
    Delete_Hierarchy_Devices: "Delete Hierarchy Devices",
    DELETE_MICRO_LOCATION: "DELETE MICRO LOCATION",
    DELETE_MICRO_LOCATIONS: "DELETE SELECTED MICRO LOCATIONS",
    Delete_Pay_Group: "Delete Pay Group",
    Delete_Pay_Type: "Delete Pay Type",
    Delete_Punch: "Delete Punch",
    Delete_Selected_Devices: "Delete Selected Devices",
    DELETE_SELECTED_FACE_SPACES: "DELETE SELECTED FACE SPACES",
    DELETE_SELECTED_USER: "DELETE SELECTED USER",
    DELETE_SELECTED_USERS: "DELETE SELECTED USERS",
    Delete_Employee_Devices: "Delete Employee Devices",
    Description: "Description",
    DeSelectAll: "Deselect All",
    Details: "Details",
    DETAILS: "DETAILS",
    Device: "Device",
    Device_deleted_successfully: "Device was successfully deleted!",
    Device_Location_not_found: "Device Location not found",
    Device_Logs: "Device Logs",
    Device_Name: "Device Name",
    Device_Selected: "1 Device Selected",
    Devices: "Devices",
    DEVICES: "DEVICES",
    DisableLocationExceptions: "Disable Location Exceptions",
    DiffWithPrevious: "Diff",
    Do_Not_Require_Photo_On_Punch: "Do Not Require Photo On Punch",
    Do_Not_Require_Photo_On_Transfer: "Do Not Require Photo On Transfer",
    Do_you_want_to_change_payroll: "Do you want to change the payroll?",
    DoubleOvertimeHours: "OT2",
    Download: "Download",
    DownloadPayrollFile: "Download Payroll File",
    Download_Payroll_Expenses_File: "Download Payroll Expenses File",
    DownloadPayrollReport: "Download Payroll Report",
    Duration_to_Trigger_Break: "Duration to Trigger Break",
    Edit: "Edit",
    Edit_Account_Role_Type: "Edit Account Role Type",
    Edit_All_Devices: "Edit All Devices",
    Edit_Auto_Break: "Edit Auto Break",
    Edit_Device: "Edit Device",
    Edit_Employees: "Edit Employees",
    Edit_Equipment: "Edit Equipment",
    Edit_Exceptions: "Edit Exceptions",
    Edit_Hierarchy: "Edit Hierarchy",
    Edit_Hierarchy_Devices: "Edit Hierarchy Devices",
    Edit_Pay_Group: "Edit Pay Group",
    Edit_Pay_Type: "Edit Pay Type",
    Pay_Type_Code: "Pay Type Code",
    Edit_Timecard: "Edit Timecard",
    Edit_Timecards: "Edit Timecards",
    Edit_Employee_Devices: "Edit Employee Devices",
    EditPosition: "Edit Position",
    Email_already_in_use: "Email already in use.",
    Email_cannot_be_empty: "Email cannot be empty",
    Employee: "Employee",
    Employee_created_successfully: "Employee was successfully created!",
    Employee_Devices: "Employee Devices",
    Employee_Edit: "Employee Edit",
    Employee_Hierarchy: "Employee Hierarchy",
    Employee_ID: "Employee ID",
    Employee_ID_cannot_be_empty: "Employee ID cannot be empty.",
    Employee_ID_must_be_unique: "Employee ID must be unique",
    Employee_is_required: "Employee is required.",
    Employee_Selected: "1 Employee Selected",
    Employees: "Employees",
    EMPLOYEES: "EMPLOYEES",
    Enable_Auto_Transfer: "Enable Auto Transfer",
    Enable_Equipment: "Enable Equipment",
    Enable_Hierarchy: "Enable Hierarchy",
    Enable_I9_Workflow: "Enable I9 Workflow",
    Enable_Location_Exception_on_Transfer: "Enable Location Exception on Transfer",
    Enable_Mobile_Time_Fraud_Prevention: "Enable Mobile Time Fraud Prevention",
    Enable_Payroll: "Enable Payroll",
    Enable_Date_Time_Edit: "Enable Date/Time Edit",
    Enable_Timecards: "Enable Timecards",
    EnableLocationException: "Enable Location Exception",
    Ensure_following_on_mobile_device: "Ensure the following on the mobile device:",
    Equipment: "Equipment",
    Equipment_created_successfully: "Equipment was successfully created!",
    Equipment_deleted_successfully: "Equipment was successfully deleted!",
    Equipment_Distribution: "Equipment Distribution",
    Equipment_Selected: "1 Equipment Selected",
    Client_Selected: "1 Client Selected",
    Error: "Error",
    Exception: "Exception",
    EXCEPTION: "EXCEPTION",
    EXCEPTIONS: "EXCEPTIONS",
    Explain_account_hierarchy_settings:
        "By default, hierarchy assignments to both employees and account users allow these users to access their default hierarchy item, and any child hierarchy items beneath their default level. By making the hierarchy assignment explicit, it will require the employee or account user to be assigned to every hierarchy item to access that item. This allows for assignments that do not easily follow parent and child relationships.",
    Export_Payroll: "Export Payroll",
    Export_X_employees_with_unapproved_time: "Export {0} employee(s) with unapproved time",
    ExportAllTimecardsBody: "Are you sure you want to create and download the payroll file and mark all timecards in this payperiod as exported?",
    ExportAllTimecardsTitle: "Payroll File Export",
    Exported: "Exported",
    ExportPayrollFile: "Export Payroll File",
    External_ID: "External ID",
    External_ID2: "External ID 2",
    External_ID3: "External ID 3",
    External_ID_cannot_be_empty: "External ID cannot be empty.",
    External_ID_must_be_unique: "External ID must be unique",
    face_spaces: "face spaces",
    FACE_SPACES: "FACE SPACES",
    Failed_to_add_punch: "Failed to add punch",
    Failed_to_add_UserRole: "Failed to add UserRole",
    Failed_to_approve_Timecard: "Failed to approve Timecard",
    Failed_to_delete_punch: "Failed to delete punch",
    Failed_to_export_payroll_Please_try_again_later: "Failed to export payroll. Please try again later",
    Failed_to_get_payroll_Please_try_again_later: "Failed to get payroll. Please try again later",
    Failed_to_lock_payroll_Please_try_again_later: "Failed to lock payroll. Please try again later",
    Failed_to_remove_Account_User: "Failed to remove Account User",
    Failed_to_remove_Account_Users: "Failed to remove Account Users",
    Failed_to_remove_UserRole: "Failed to remove UserRole",
    Failed_to_unapprove_Timecard: "Failed to unapprove Timecard",
    Failed_to_unlock_payroll_Please_try_again_later: "Failed to unlock payroll. Please try again later",
    Failed_to_update_punch_for_lock_period: "Failed to update punch for lock period",
    Failed_to_update_UserRole: "Failed to update UserRole",
    Features: "Features",
    First_Name: "First Name",
    First_Name_cannot_be_empty: "First Name cannot be empty.",
    LongRunning: "Long Running",
    Finished: "Finished",
    it_cannot_be_longer_than_x_chars: "It cannot be longer than {0} chars",
    first_week: "1st week",
    For_root: "on Root Hierarchy Level",
    General: "General",
    Geofence_Perimeter: "Geofence Perimeter (meters)",
    Geofence_Violation: "Geofence Violation",
    GPS: "GPS",
    GPS_is_enabled: "GPS is enabled",
    Hierarchies: "Hierarchies",
    Hierarchies_Selected: "Hierarchies Selected",
    Hierarchy: "Hierarchy",
    HIERARCHY: "HIERARCHY",
    Hierarchy_added_successfully: "Hierarchy was added successfully!",
    Hierarchy_already_added: "Hierarchy has already been added. Please choose a different hierarchy name.",
    Hierarchy_Children: "Hierarchy Children",
    Hierarchy_deleted_successfully: "Deleted successfully!",
    Hierarchy_Details: "Hierarchy Details",
    Hierarchy_Devices: "Hierarchy Devices",
    Hierarchy_Distribution: "Hierarchy Distribution",
    Hierarchy_Employees: "Hierarchy Employees",
    Hierarchy_Item_Selected: "Hierarchy Item Selected",
    Hierarchy_Location: "Hierarchy Location",
    Hierarchy_Name: "Hierarchy Name",
    Hierarchy_Position: "Hierarchy Position",
    Hierarchy_Positions: "{0} Hierarchy Positions",
    Hierarchy_Positions_Table_Title: "Hierarchy Positions",
    Hierarchy_Punch_Report: "Hierarchy Punch Report",
    Hierarchy_Records: "Hierarchy Records",
    Hierarchy_Selected: "Hierarchy Selected",
    Hierarchy_Settings: "Hierarchy Settings",
    Hierarchy_Users: "Hierarchy Users",
    HierarchyDefinitions: "Hierarchy Definitions",
    HierarchyItemLabel: "Item Label",
    HierarchyLevel: "Hierarchy Level",
    History: "History",
    Home_Hierarchy: "Home Hierarchy",
    Hours_Worked: "Hours Worked",
    Id: "Id",
    Image: "Image",
    In: "In",
    InactiveUsers: "Inactive Users",
    Include_employees_that_have_already_been_exported: "Include employees that have already been exported",
    Individual_Mode: "Individual Mode",
    Input_a_valid_value: "Input a valid value.",
    Input_valid_integer: "Input a valid integer.",
    Invalid_email_format: "Invalid email format.",
    invalid_email_password_combo: "Oops! that email / password combination is not valid.",
    Invalid_External_Id: "Invalid External Id",
    Invalid_ID_format: "Invalid ID format.",
    iOS_warning_body:
        "This Web application is not intended to be viewed in iOS. This device may not render the application correctly. It is recommend that you use a full browser for the best experience",
    iOS_warning_title: "WARNING: Unsupported iOS Device",
    Is_this_x: "Is this {0} {1}?",
    IsAdmin: "Is Account Admin",
    Item: "Item",
    Job_Costing_Summary: "Job Costing Summary",
    Language_Id: "Language Id",
    LastRunTime: "Last Run Time",
    Last_employee_has_not_image: "Last employee has not image.",
    Last_Month: "Last Month",
    Last_Name: "Last Name",
    Last_Name_cannot_be_empty: "Last Name cannot be empty.",
    Last_Pay_Period: "Previous Pay Period",
    Last_Time: "Last Time",
    Last_Week: "Last Week",
    LAT_LNG: "LAT/LNG",
    Latitude: "Latitude",
    Level: "Level",
    Level_is_disabled_for_employees: "{0} level is disabled for Employees",
    Linked_Account_Position: "Linked Account Position",
    List: "List",
    Liveness_Score: "Liveness Score",
    Localization: "Localization",
    Location: "Location",
    Location_enabled_Findd_app: "Location services are enabled for this app",
    Location_Exception: "Location Exception",
    Location_Name: "Location Name",
    Location_not_available: "Location is not available",
    Location_Selected: "1 Location Selected",
    Locations: "Locations",
    LOCATIONS: "LOCATIONS",
    Lock: "Lock",
    Lock_Payroll: "Lock Payroll",
    Lock_Payroll_Hierarchy: "Lock Payroll Hierarchy",
    Locked: "Locked",
    Login: "Login",
    Login_Email: "Login Email",
    Longitude: "Longitude",
    Manual_Punch: "Manual Punch",
    Map: "Map",
    Max_PunchSet_Length_hours: "Max PunchSet Length(hours)",
    meters: "meter(s)",
    Message_Center: "Message Center",
    Message: "Message",
    No_Messages: "No Messages",
    kilometers: "kilometer(s)",
    Micro_Location_Selected: "1 Micro Location Selected",
    Micro_Locations: "Micro Locations",
    minutes: "minutes",
    Missing: "Missing",
    Open_Punches: "Open Punches",
    Mobile: "Mobile",
    MobileClockMode: "Mobile Clock Mode",
    Monthly: "Monthly",
    Multiple_Locations: "Multiple Locations",
    Name: "Name",
    Name_cannot_be_empty: "Name cannot be empty.",
    NameRequired: "Name Required",
    New_Pay_Group: "New Pay Group",
    New_Pay_Type: "New Pay Type",
    Next_Week: "Next Week",
    NextRunTime: "Next Run Time",
    No: "No",
    No_device_found: "No device found!",
    NoCompileError: "No compile errors",
    No_Device_Location: "No Device Location",
    No_Equipment: "No Equipment",
    No_equipment_found: "No equipment found!",
    No_GPS_Location: "No GPS Location",
    No_GPSBeacon: "No GPS/Beacon",
    No_Hierarchy: "No Hierarchy",
    No_hierarchy_found: "No hierarchy found!",
    No_hierarchy_level: "No hierarchy level",
    No_image: "No image.",
    No_Job_Costing_Summary_Data: "No Job Costing Summary Data",
    No_known_metadata_for_this_equipment: "No known metadata for this equipment",
    No_Level: "No {0}",
    No_Location: "No Location",
    No_Location_Data: "No Location Data",
    No_Microlocation_In_Range: "No Microlocation In Range",
    No_Pay_Type: "No Pay Type",
    No_Payroll_Time_by_Hierarchy_Data: "No Payroll Time by Hierarchy Data",
    No_Payroll_Expenses_by_Hierarchy_Data: "No Payroll Expenses by Hierarchy Data",
    No_Position: "No Position",
    No_Positions_found: "No Positions found",
    No_User_Role: "No User Role",
    not_inherited: "not inherited",
    Not_Reviewed: "Not Reviewed",
    NotApproved: "Not Approved",
    Note: "Note",
    NoteSubscriberList: "Subscriber Email List (comma seperated)",
    NoteSubscriberListError: "Incorrect format for email list. Please seperate each valid email with a comma.",
    NoteSubscribers: "Subscribers",
    NoteType: "Note Type",
    NoteTypes: "Note Types",
    NoNoteTypes: "No Note Types",
    FrontEndFormScript: "Custom Form",
    AreYouSureYouWantToDeleteNoteType: "Are you sure you want to delete note type?",
    NotFindPage: "404 ERROR",
    NoUnlockTimecard: "Cannot Unlock Timecard",
    NoUnlockTimecardBody: "This timecard has already been exported. Cannot unlock a timecard that has already been exported to payroll.",
    OK: "OK",
    Only_account_admin_can_have_root_level: "Only account admin can have root level.",
    OptionalTasks: "Optional Tasks",
    Original_Timecard: "Original Timecard",
    Modified_Timecard: "Modified Timecard",
    Pending_Difference_Timecard: "Pending Difference Timecard",
    Exported_Difference_Timecard: "Exported Difference Timecard",
    OT_Hours: "OT Hrs",
    OT2_Hours: "OT2 Hrs",
    Other: "Other",
    Out: "Out",
    Override: "Override",
    Override_Rate: "Override Rate",
    Overtime: "Overtime",
    OvertimeHours: "OT",
    Paid_Time: "Paid Time",
    Password: "Password",
    Password_Confirm_Required: "Password confirm required.",
    Password_Confirmation: "Password Confirmation",
    Password_required: "Password required.",
    Passwords_must_match: "Passwords must match.",
    Pay: "Pay",
    Pay_Calendar: "Pay Calendar",
    Pay_Calendar_Day1: "Pay Calendar Day1 (1-15)",
    Pay_Calendar_Day2: "Pay Calendar Day2 (16-28)",
    Pay_Calendar_Property: "Pay Calendar Property",
    Pay_Calendar_Start_Date: "Pay Calendar Start Date",
    Pay_Calendar_Start_Date_and_Pay_Period_Start_Day_match: "The Pay Calendar Start Date and the Pay Period Start Day should be the same day of the week.",
    Pay_Calendar_Start_Day: "Pay Calendar Start Day (1-28)",
    Pay_Calendar_Type: "Pay Calendar Type",
    Pay_Configuration: "Pay Configuration",
    Pay_Group: "Pay Group",
    Pay_Group_Name: "Pay Group Name",
    Pay_Group_Selected: "Pay Group Selected",
    Pay_Groups: "Pay Groups",
    Pay_Period: "Pay Period",
    Pay_Period_Length: "Pay Period Length",
    Pay_Period_Start_Day: "Pay Period Start Day",
    Pay_Rate: "Pay Rate",
    Pay_Type: "Pay Type",
    Pay_Type_Name: "Pay Type Name",
    Pay_Type_Selected: "Pay Type Selected",
    Pay_Type_Required: "Pay Type Required",
    Pay_Types: "Pay Types",
    Require_at_least_one_PayType: "Require at least one PayType",
    Payroll: "Payroll",
    Payroll_by_Hierarchy: "Payroll by Hierarchy",
    Payroll_exported_successfully: "Payroll was exported successfully!",
    Payroll_Hierarchy: "Payroll Hierarchy",
    Payroll_Hierarchy_Level: "Payroll Hierarchy Level",
    Payroll_Hours_Summary: "Payroll Hours Summary",
    Payroll_locked_successfully: "Payroll was locked successfully!",
    Payroll_unlocked_successfully: "Payroll was unlocked successfully!",
    PayrollExportName: "Payroll Export Name",
    PayType_created_successfully: "PayType was created successfully!",
    PayType_removed_successfully: "PayType was removed successfully!",
    PayType_updated_successfully: "PayType was updated successfully!",
    Permissions: "Permissions",
    Please_choose_an_employee: "Please choose an employee.",
    Please_choose_employee: "Please choose employee",
    Please_choose_payroll_hierarchy: "Please choose payroll hierarchy",
    Please_try_again_to_update_hierarchy: "Please, try again to update hierarchy!",
    Position: "Position",
    Position_added_successfully: "Position was added successfully!",
    Position_deleted_successfully: "Removed or Unlinked successfully!",
    Position_Distribution: "Position Distribution",
    Position_updated_successfully: "Position was updated successfully!",
    Positions: "Positions",
    Positions_selected: "{0} Positions",
    Provide_Clock_PIN: "Please enter Clock PIN",
    Running: "Running",
    Provide_External_ID: "Please enter External ID",
    Punch_added_manually: "Punch added manually",
    Punch_added_successfully: "Punch was added successfully!",
    Punch_added_without_image: "Punch added without image",
    Punch_Records: "Punch Records",
    Punch_set_calculation_date: "Punch Set Calculation Date:",
    Record_Selected: "1 Record Selected",
    Records: "Records",
    RECORDS: "RECORDS",
    Reg_Hours: "Reg Hrs",
    Registration_Code: "Registration Code",
    Registration_code_cannot_be_empty: "Registration code cannot be empty.",
    Registration_code_could_not_be_found: "Registration code could not be found",
    Mode: "Mode",
    RegularHours: "Reg",
    REJECT: "REJECT",
    Reject_All: "Reject All",
    Reject_Unsure: "Reject / Unsure",
    Rejected: "Rejected",
    REMOVE: "REMOVE",
    ReportDate: "Report Date",
    Reports: "Reports",
    Require_Explicit_Account_User_Hierarchy_Assignment: "Require Explicit Account User Hierarchy Assignment",
    Require_Explicit_Employee_Hierarchy_Assignment: "Require Explicit Employee Hierarchy Assignment",
    RequiredTasks: "Required Tasks",
    Role: "Role",
    Role_Selected: "Role Selected",
    Role_Type: "Role Type",
    Roles: "Roles",
    Rounded: "Rounded",
    RoundedFrom: "Rounded From",
    RoundingRules: "Rounding Rules",
    Rows_per_page: "Rows per page:",
    Save: "Save",
    SAVE: "SAVE",
    search: "search",
    Search: "Search",
    Refresh: "Refresh",
    second_week: "2nd week",
    third_week: "3rd week",
    Select_Pay_Type: "Select Pay Type",
    SelectAll: "Select All",
    Selected_employee_unapproved_Are_you_sure_you_want_to_export_employee: "Selected employee's time has not yet been approved. Are you sure you want to export this employee's payroll?",
    Selected_employee_unapproved_Are_you_sure_you_want_to_export_employees: "{0} employee has time that has not yet been approved. Are you sure you want to export {1} employee's payroll?",
    Selected_employees_unapproved_Are_you_sure_you_want_to_export_employees: "{0} employees have time that has not yet been approved. Are you sure you want to export {1} employees' payroll?",
    SelectPosition: "Select Position",
    SelectPositionTitle: "Select Position",
    Semi_Monthly: "Semi Monthly",
    Sensor_ID: "Sensor ID",
    Set_Password: "Set Password",
    Settings: "Settings",
    ShowComponentTimecards: "Show Component Timecards",
    something_went_wrong: "Oops! something went wrong.",
    Something_went_wrong: "Sorry something went wrong :(",
    State_Province_Region: "State/Province/Region",
    Street_Address: "Street Address, P.O. box, co. name, c/o",
    Successfully_deleted: "Successfully deleted",
    Successfully_updated: "Successfully updated",
    Successfully_unassigned: "Successfully unassigned",
    ShowSystemJobs: "Show System Jobs",
    ShowAllAccountSystemJobs: "Show All Account System Jobs",
    Tags: "Tags",
    Task: "1 Task",
    x_Tasks: "{0} Tasks",
    The_last_punch_was_added_manually: "The last punch was added manually.",
    The_name_cannot_be_longer_than: "The name cannot be longer than 30 characters.",
    The_name_must_be_unique: "The name must be unique.",
    The_pay_type_code_must_be_unique: "the Pay Type Code must be unique",
    The_number_is_too_high: "The number is too high.",
    The_number_is_too_low: "The number is too low.",
    There_is_no_Auto_Break_item: "There is no Auto Break item.",
    There_is_no_pay_group: "There is no pay group.",
    There_is_no_pay_type: "There is no pay type.",
    There_is_no_work_history: "There is no work history",
    This_employee_has_been_deleted: "This employee has been deleted!",
    This_Employee_has_No_Hierarchies: "This Employee has No Hierarchy.",
    This_employee_has_not_image: "This employee has no image.",
    This_equipment_has_not_history: "Equipment has no history.",
    This_field_is_required: "This field is required.",
    This_field_requires_a_number_between_0_and_100: "This field requires a number between 0 and 100.",
    This_field_requires_a_number_between_0_and_1000: "This field requires a number between 0 and 1000.",
    This_field_requires_a_number_between_1_and_24: "This field requires a number between 1 and 24.",
    This_field_requires_a_number_between_1_and_5: "This field requires a number between 1 and 5.",
    This_field_requires_an_integer_between_1_and_28: "This field requires an integer between 1 and 28.",
    This_field_requires_an_integer_between_2_and_10: "This field requires an integer between 2 and 10.",
    This_field_requires_a_number_greater_than_0: "This field requires a number greater than 0",
    This_field_requires_minimum_10_chars: "This field requires minimum 10 chars.",
    This_hierarchy_item_cant_be_assigned: "This hierarchy item can't be assigned",
    This_is_a_required_field: "This is a required field.",
    This_is_x: "This is {0}",
    Invalid_for_employee: "Invalid for employee",
    This_Month: "This Month",
    This_Pay_Period: "Current Pay Period",
    This_Pay_Type_is_used_as_a_default_Pay_Type_Cannot_remove_it: "This Pay Type is used as a default Pay Type. Cannot remove it.",
    This_Pay_Type_is_used_Cannot_remove_it: "This Pay Type is used. Cannot remove it.",
    This_Week: "This Week",
    ThisIsALocation: "This is a Location (GPS)",
    ThisIsAMicroLocation: "This is a MicroLocation (Beacon)",
    Time: "Time",
    Timecard: "Timecard",
    Timecard_approved_successfully: "Timecard was approved successfully!",
    Timecard_unapproved_successfully: "Timecard was unapproved successfully!",
    TimecardApprovedMessage: "Timecard approved and locked. Timecards cannot be changed once approved.",
    TimecardAuditReport: "Timecard Audit Report",
    Timecards: "Timecards",
    TIMECARDS: "TIMECARDS",
    TimecardSummaryReport: "Timecard Summary Report",
    Today: "Today",
    Top: "Top",
    Total_Hours_By_Day: "Total Hours By Day",
    TOTAL_RECORDS: "TOTAL RECORDS",
    WorkingTotalHours: "Working Total Hrs",
    TotalHours: "Total Hrs",
    Total: "Total",
    Trained_Date: "Trained Date",
    Training_Face_Spaces: "# of Training Face Spaces",
    TransferDataTo: "Transfer Data To:",
    Unapprove: "Unapprove",
    Unapprove_all_timecards: "Unapprove all timecards (count {0})",
    Unapprove_Timecard: "Unapprove Timecard",
    Unapprove_timecards_on_this_page: "Unapprove timecards on this page (count {0})",
    Unlock: "Unlock",
    Unlock_Payroll_Hierarchy: "Unlock Payroll Hierarchy",
    UnlockTimecard: "Unlock Timecard?",
    Unutilized: "Unutilized",
    Update: "Update",
    UPDATE_PROFILE_IMAGE: "UPDATE PROFILE IMAGE",
    Use_Towards_Overtime: "Use Towards Overtime",
    user_email: "User email",
    user_password: "User password",
    user_password_confirm: "user password confirm",
    User_Role: "User Role",
    User_role_name_is_duplicated: "User role name is duplicated.",
    User_Roles: "User Roles",
    User_save_failed: "User save failed!",
    User_saved_successfully: "User was successfully saved!",
    User_Selected: "1 User Selected",
    UserRole_added_successfully: "UserRole was added successfully!",
    UserRole_removed_successfully: "UserRole was removed successfully!",
    UserRole_updated_successfully: "UserRole was updated successfully!",
    Users: "Users",
    Utilization: "Utilization",
    Utilized: "Utilized",
    Valid_email_required: "Valid email address required.",
    Valid_value_required: "Valid value required",
    ValidLocationRequired: "Valid Location Required",
    View: "View",
    View_All_Devices: "View All Devices",
    View_Employees: "View Employees",
    View_Equipment: "View Equipment",
    View_Full_Hierarchy: "View Full Hierarchy",
    View_Hierarchy_Devices: "View Hierarchy Devices",
    View_next_timecard: "View next timecard",
    View_Payroll: "View Payroll",
    View_previous_timecard: "View previous timecard",
    View_Records: "View Records",
    View_Timecards: "View Timecards",
    View_Employee_Devices: "View Employee Devices",
    Warn_No_Signature_Text: "Warn No Signature Text",
    Weekly: "Weekly",
    WIFI_is_on: "WIFI is on",
    X_Account_Users: "{0} Account Users",
    x_Devices_Selected: "{0} Devices Selected",
    X_employee_have_time_that_has_not_yet_been_approved: "{0} employee(s) have time that has not yet been approved.",
    X_employee_payroll_have_already_been_exported: "{0} employee(s) payroll have already been exported.",
    x_Employees_Selected: "{0} Employees Selected",
    x_Equipment_Selected: "{0} Equipment Selected",
    x_Client_Selected: "{0} Client Selected",
    x_Hierarchy_Items_Selected: "{0} Hierarchy Items Selected",
    x_Locations_Selected: "{0} Locations Selected",
    x_Micro_Locations_Selected: "{0} Micro Locations Selected",
    x_Records: "{0} Records",
    x_Records_Selected: "{0} Records Selected",
    x_Roles_Selected: "{0} Roles Selected",
    x_Selected: "{0} Selected",
    x_Users_Selected: "{0} Users Selected",
    x_week: "{0}th week",
    xxx_hierarchy_definition_has_not_any_hierarchy_items: 'You can not choose "{0}" level, because this has not any hierarchy items.',
    You_cannot_delete_yourself: "You cannot delete yourself.",
    You_cannot_remove_your_AccountAdmin_permission: "You cannot remove your AccountAdmin Permission",
    You_cant_access_this_hierarchy_item: "You can't access this hierarchy item.",
    You_cant_choose_this_hierarchy_item: "You can't choose this hierarchy item.",
    You_cant_delete_pay_group: "Cannot delete PayGroup while attached to hierarchy item.",
    You_cant_delete_pay_type: "Cannot delete PayType while set as default in PayGroup.",
    Zip_Postal_code: "Zip/Postal code",
    Accrual_Name: "Accrual Name",
    Accrual_Code: "Accrual Code",
    Rate_Per_Hour: "Rate Per Hour",
    Use_for_Leave_Tracking: "Use for Leave Tracking",
    Leave_Tracking_Pay_Type: "Leave Tracking Pay Type",
    Allow_Time_Off_PayRate_Edit: "Allow Time Off PayRate Edit",
    No_Accrual: "No Accrual",
    Add_Accrual: "Add Accrual",
    Edit_Accrual: "Edit Accrual",
    Accrual_Rate_Per_Hour: "Accrual Rate Per Hour",
    Pay_Types_Contributing_To_Accrual: "Pay Types Contributing To Accrual",
    Allow_Accrual_For_Leave_Tracking: "Allow Accrual For Leave Tracking",
    Require_Note_On_Time_Off_Approval: "Require Note On Time Off Approval",
    Pay_Type_Used_for_Leave_Punch_Set: "Pay Type Used for Leave Punch Set",
    Deduction_Rate_Per_Hour_for_Leave: "Deduction Rate Per Hour for Leave (must be negative)",
    Invalid_format: "Invalid format",
    This_field_must_be_greater_than_or_equal_to_zero: "This field must be greater than or equal to 0",
    This_field_must_be_less_than_x: "This field must be less than {0}",
    This_field_must_be_less_than_or_equal_to_x: "This field must be less than or equal to {0}",
    This_field_must_be_greater_than_x: "This field must be greater than {0}",
    This_field_must_be_greater_than_or_equal_to_x: "This field must be greater than or equal to {0}",
    Accrual_created_successfully: "Accrual created successfully",
    Accrual_updated_successfully: "Accrual updated successfully",
    Delete_Accrual: "Delete Accrual",
    Are_you_sure_delete_accrual: "Are you sure you want to delete this Accrual?",
    Accrual_removed_successfully: "Accrual removed successfully",
    Add_Accrual_to_Employee: "Add Accrual to Employee",
    Edit_Accrual_to_Employee: "Edit Accrual to Employee",
    Balance: "Balance",
    Accrual_Start_Date: "Accrual Start Date",
    Accrual_Probation_End_Date: "Accrual Probation End Date",
    Probation_End_Date: "Probation End Date",
    Accrual_Type: "Accrual Type",
    Invalid_date_range: "Invalid date range",
    Are_you_sure_you_want_to_change_balance: "Are you sure you really want to change the balance?",
    Starting_Balance: "Starting Balance",
    Current_Balance: "Current Balance",
    Pending_Balance: "Pending Balance",
    Accrual_Selected: "Accrual Selected",
    Employee_Accrual_Changing_Information: "Employee Accrual Audit",
    Employee_accrual_added_successfully: "Employee accrual added successfully.",
    Employee_accrual_updated_successfully: "Employee accrual updated successfully.",
    Employee_accrual_removed_successfully: "Employee accrual removed successfully.",
    Enable_Accruals_Timeoff: "Enable Accruals/Time off",
    Leave_Tracking: "Leave Tracking",
    New_Leave_Request: "New Leave Request",
    Edit_Leave_Request: "Edit Leave Request",
    Accrual: "Accrual",
    Hours: "Hours",
    HoursAbbreviation: "Hrs",
    Hours_Per_Day: "Hours Per Day",
    Type: "Type",
    Vacation: "Vacation",
    Sick_leave: "Sick leave",
    Leave_Start_Date: "Leave Start Date",
    Leave_End_Date: "Leave End Date",
    Comments: "Comments",
    Leave_request_saved_successfully: "Leave request saved successfully.",
    Leave_Request_Selected: "1 Leave Request Selected",
    x_Leave_Requests_Selected: "{0} Leave Requests Selected",
    Are_you_sure_you_want_to_delete_selected_leave_request: "Are you sure you want to delete the selected leave request(s)?",
    Pending: "Pending",
    Denied: "Denied",
    Start_Date: "Start Date",
    End_Date: "End Date",
    End_Date_cannot_be_before_Start_Date: "End Date cannot be before Start Date",
    No_leave_tracking_found: "No leave tracking found!",
    Status: "Status",
    Dates: "Dates",
    Notes: "Notes",
    Cannot_update_none_pending_leave_request: "Cannot update previously approved or denied leave requests.",
    Cannot_update_leave_request_for_locked_period_or_denied_leave_request: "Cannot update leave request for locked period or denied leave request",
    Leave_request_updated_successfully: "Leave request updated successfully.",
    Choose_leave_requests_to_approve: "Please choose leave requests to approve.",
    Choose_leave_requests_to_deny: "Please choose leave requests to deny.",
    One_or_more_leave_request_comments_are_required: "One or More Leave Request's comments are required",
    Pay_Rate_cannot_entered_for_this_request_as_this_is_not_paid_leave: "Pay Rate cannot entered for this request as this is not paid leave",
    Cannot_approve_the_approved_or_denied_leave_request: "Cannot approve the approved or denied leave request(s)",
    Cannot_deny_the_denied_leave_request: "Cannot deny the denied leave request(s)",
    Leave_request_approved_successfully: "Leave request(s) approved successfully.",
    Leave_request_denied_successfully: "Leave request(s) denied successfully.",
    Are_you_sure_you_want_to_approve_selected_leave_request: "Are you sure you want to approve the selected leave request(s)?",
    Are_you_sure_you_want_to_deny_selected_leave_request: "Are you sure you want to deny the selected leave request(s)?",
    Timezone: "Timezone",
    Hierarchy_Timezone: "Hierarchy Timezone",
    No_Overtime: "No Overtime",
    Unpaid: "Unpaid",
    Leave_Tracking_Note_History: "Leave Tracking Note History",
    Edit_Note: "Edit Note",
    Remove_Note: "Remove Note",
    Are_you_sure_remove_note: "Are you sure you want to remove this note?",
    Closed: "Closed",
    Close_Payroll: "Close Payroll",
    Close_Payroll_Hierarchy: "Close Payroll Hierarchy",
    Are_you_sure_you_want_to_close_payroll_hierarchy_with_leave:
        "Are you sure you want to close payroll hierarchy? Closing payroll will trigger accrual calculations for the closed pay period, as well as add all approved time off requests to timecards for this pay period. All unapproved time off requests will automatically be rejected. Accrual calculations cannot be undone.",
    Are_you_sure_you_want_to_close_payroll_hierarchies_with_leave:
        "Are you sure you want to close {0} payroll hierarchies? Closing payroll will trigger accrual calculations for the closed pay period, as well as add all approved time off requests to timecards for this pay period. All unapproved time off requests will automatically be rejected. Accrual calculations cannot be undone.",
    Payroll_closed_successfully: "Payroll was closed successfully!",
    Failed_to_close_payroll_Please_try_again_later: "Failed to close payroll. Please try again later",
    Enable_Schedule: "Enable Schedule",
    Schedules: "Schedules",
    Shift_Templates: "Shift Templates",
    Pattern_Templates: "Pattern Templates",
    Schedule_Templates: "Schedule Templates",
    Schedule_Planners: "Schedule Planners",
    Posted_Schedules: "Posted Schedules",
    Position_Color: "Position Color",
    No_shift_template_found: "No shift template found!",
    Show_All_Child_Hierarchy_Data: "Show All Child Hierarchy Data",
    Start_Time: "Start Time",
    End_Time: "End Time",
    Breaks: "Breaks",
    Early_In_Restriction: "Early In Restriction",
    Early_In_Restriction_ShortTerm: "E Restrict",
    Differential_Pay: "Differential Pay",
    Differential_Pay_ShortTerm: "Diff Pay",
    New_Shift_Template: "New Shift Template",
    Edit_Shift_Template: "Edit Shift Template",
    Early_Punch_In_Restriction: "Early Punch In Restriction",
    Early_Punch_In_Restriction_Value: "Early Punch In Restriction Value",
    Edit_Break: "Edit Break",
    New_Break: "New Break",
    Break_Start_Time_Window: "Break Start Time Window",
    Break_End_Time_Window: "Break End Time Window",
    Minimum_Break_Duration: "Min Break Duration",
    Maximum_Break_Duration: "Max Break Duration",
    Recommended_Break_Duration: "Recommended Break Duration",
    Require_Punch_Biometrics: "Require Punch Biometrics",
    Break_name_is_duplicated: "Break name is duplicated.",
    Are_you_sure_you_want_to_delete_this_break: "Are you sure you want to delete this break?",
    Shift_template_added_successfully: "Shift template added successfully.",
    Shift_template_updated_successfully: "Shift template updated successfully.",
    Shift_template_deleted_successfully: "Shift template(s) deleted successfully.",
    Are_you_sure_you_want_to_delete_the_selected_shift_template: "Are you sure you want to delete the selected shift template(s)?",
    Shift_Template_Selected: "Shift Template Selected",
    x_Shift_Templates_Selected: "{0} Shift Templates Selected",
    Pattern_Template_Selected: "Pattern Template Selected",
    x_Pattern_Template_Selected: "{0} Pattern Templates Selected",
    Are_you_sure_you_want_to_delete_the_selected_pattern_template: "Are you sure you want to delete the selected pattern template(s)?",
    No_pattern_template_found: "No pattern template found!",
    Pattern_template_added_successfully: "Pattern template added successfully.",
    Pattern_template_updated_successfully: "Pattern template updated successfully.",
    Pattern_template_deleted_successfully: "Pattern template(s) deleted successfully.",
    New_Pattern_Template: "New Pattern Template",
    Edit_Pattern_Template: "Edit Pattern Template",
    Add_Shift_Template: "Add Shift Template",
    Shift_Template: "Shift Template",
    Shift_template_time_is_overlapped: "Shift template time is overlapped",
    Cannot_overlap_shift_template_times: "Cannot overlap the shift tempalte times",
    Shift_template_time_updated_successfully: "Shift template time updated successfully",
    Remove: "Remove",
    Are_you_sure_you_want_to_remove_this_shift_template: "Are you sure you want to remove this shift template?",
    Shift_template_time_removed_successfully: "Shift template time removed successfully",
    Edit_Shift_Time: "Edit Shift Time",
    Schedule_template_added_successfully: "Schedule template added successfully",
    Schedule_template_deleted_successfully: "Schedule template deleted successfully",
    Schedule_template_updated_successfully: "Schedule template updated successfully",
    Are_you_sure_you_want_to_delete_the_selected_schedule_template: "Are you sure you want to delete the selected schedule template(s)?",
    Schedule_Template_Selected: "Schedule Template Selected",
    x_Schedule_Templates_Selected: "{0} Schedule Templates Selected",
    No_schedule_template_found: "No schedule template found!",
    New_Schedule_Template: "New Schedule Template",
    Edit_Schedule_Template: "Edit Schedule Template",
    Schedule_Template: "Schedule Template",
    Shifts: "Shifts",
    Week_View: "Week View",
    Day_View: "Day View",
    Shifts_must_be_added_to_week_view: "Shifts must be added to week view",
    Qty: "Qty",
    Add_Shift: "Add Shift",
    Pattern_Template: "Pattern Template",
    Shift_added_successfully: "Shift added successfully",
    Shift_deleted_successfully: "Shift deleted successfully",
    Shift_Selected: "Shift Selected",
    x_Shifts_Selected: "{0} Shifts Selected",
    Are_you_sure_you_want_to_delete_the_selected_shift: "Are you sure you want to delete the selected shift(s)?",
    No_shift_found: "No shift found",
    Sunday: "Sunday",
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday",
    Multiple_Positions: "Multiple Positions",
    First_Shift_Start_Time: "First Shift Start Time",
    Last_Shift_End_Time: "Last Shift End Time",
    Add_New_Schedule_Planner: "Add New Schedule Planner",
    Pay_Group_added_successfully: "Pay Group added successfully.",
    Pay_Group_updated_successfully: "Pay Group updated successfully.",
    Pay_Group_removed_successfully: "Pay Group removed successfully.",
    Cannot_add_before_probation_end_date: "Cannot add before probation end date '{0}'",
    Accrual_name_is_duplicated: "Accrual name is duplicated.",
    Pay_Type_name_requires_maximum_15_chars: "Pay Type name requires maximum 15 chars",
    Leave_request_saved_and_approved_successfully: "Leave request saved and approved successfully.",
    Leave_request_updated_and_approved_successfully: "Leave request updated and approved successfully.",
    Next_Month: "Next Month",
    Day: "Day",
    View_Accrual: "View Accrual",
    View_Employee_Accrual: "View Employee Accrual",
    Edit_Employee_Accrual: "Edit Employee Accrual",
    Add_Employee_Accrual: "Add Employee Accrual",
    Delete_Employee_Accrual: "Delete Employee Accrual",
    View_Leave_Tracking: "View Leave Tracking",
    Edit_Leave_Tracking: "Edit Leave Tracking",
    Add_Leave_Tracking: "Add Leave Tracking",
    Delete_Leave_Tracking: "Delete Leave Tracking",
    View_Employee_Leave_Tracking: "View Employee Leave Tracking",
    Edit_Employee_Leave_Tracking: "Edit Employee Leave Tracking",
    Add_Employee_Leave_Tracking: "Add Employee Leave Tracking",
    Delete_Employee_Leave_Tracking: "Delete Employee Leave Tracking",
    Schedule_added_successfully: "Schedule added successfully.",
    Total_Shifts: "Total Shifts",
    Unfilled_Shifts: "Unfilled Shifts",
    Filled_Status: "Filled Status",
    Posted: "Posted",
    Filled: "Filled",
    Post: "Post",
    Schedule_Planner: "Schedule Planner",
    Unfilled: "Unfilled",
    Assign_Employee_to_Shift: "Assign Employee to Shift",
    Assign_Candidate_to_Shift: "Assign Candidate to Shift",
    Shift_information: "Shift information",
    Shift_assigned_successfully: "Shift assigned successfully.",
    Post_Schedule: "Post Schedule",
    Schedule_Planner_posted_successfully: "Schedule Planner posted successfully.",
    You_arent_filled: "You aren't 100% filled.",
    Are_you_sure_you_want_to_post_this_schedule: "Are you sure you want to post this schedule?",
    Are_you_sure_you_want_to_post_this_schedule_anyway: "Are you sure you want to post this schedule anyway?",
    employee_will_be_alerted_once_the_schedule_is_posted: "{0} employee will be alerted once the schedule is posted",
    employees_will_be_alerted_once_the_schedule_is_posted: "{0} employees will be alerted once the schedule is posted",
    No_schedule_found: "No schedule found!",
    Schedule_Selected: "Schedule Selected",
    x_Schedules_Selected: "{0} Schedules Selected",
    Are_you_sure_you_want_to_delete_the_selected_schedule: "Are you sure you want to delete the selected schedule(s)?",
    Schedule: "Schedule",
    View_Schedule: "View Schedule",
    Edit_Schedule: "Edit Schedule",
    Add_Schedule: "Add Schedule",
    Delete_Schedule: "Delete Schedule",
    View_Employee_Schedule: "View Employee Schedule",
    Edit_Employee_Schedule: "Edit Employee Schedule",
    Add_Employee_Schedule: "Add Employee Schedule",
    Delete_Employee_Schedule: "Delete Employee Schedule",
    View_Account_Schedule: "View Account Schedule Data",
    Edit_Account_Schedule: "Edit Account Schedule Data",
    Add_Account_Schedule: "Add Account Schedule Data",
    Delete_Account_Schedule: "Delete Account Schedule Data",
    Posted_Schedule: "Posted Schedule",
    Account_Details: "Account Details",
    Week_Month: "Week/Month",
    Month_View: "Month View",
    Shift_or_Pattern_Template: "Shift or Pattern Template",
    Create_multiple_position_shift: "Create multiple position shift",
    Create_simple_position_shift: "Create simple position shift",
    Shift: "Shift",
    New_Shift: "New Shift",
    Edit_Shift: "Edit Shift",
    Shift_times_are_overlapped: "Shift times are overlapped",
    Shift_time_is_overlapped: "Shift time is overlapped",
    Create_new_shift: "Create new shift",
    Shift_time_updated_successfully: "Shift time updated successfully",
    Cannot_overlap_shift_times: "Cannot overlap shift times",
    Shift_updated_successfully: "Shift updated successfully",
    Edit_Shift_Quantity: "Edit Shift Quantity",
    Shift_quantity_updated_successfully: "Shift quantity updated successfully",
    Pattern: "Pattern",
    Pattern_name_is_duplicated: "Pattern name is duplicated",
    Invalid_shift_time: "Invalid shift time",
    Cannot_make_a_break_because_shift_time_is_not_valid: "Cannot make a break, because shift time is not valid",
    Cannot_make_a_break_because_shift_time_is_less_than_5min: "Cannot make a break, because shift time is less than 5min",
    Break_Time_Window_should_be_fall_in_shift_time: "Break Time Window should be during shift time",
    Duration_Time_Window_cannot_less_than_5min: "Duration of Time Window cannot less than 5 min",
    This_filed_should_be_less_than_Break_Time_Window_Duration: "This field should be less than BreakTimeWindow duration",
    Max_Break_Duration_should_be_greater_than_Min_Break_Duration: "Max Break Duration should be greater than Min Break Duration",
    Recommended_Break_Duration_should_be_greater_than_Min_Break_Duration: "Recommended Break Duration should be greater than Min Break Duration",
    Recommended_Break_Duration_should_be_less_than_Max_Break_Duration: "Recommended Break Duration should be less than Max Break Duration",
    Shift_name_is_duplicated: "Shift name is duplicated",
    IP_Address: "IP Address",
    New_IP_Address: "New IP Address",
    Edit_IP_Address: "Edit IP Address",
    IP_Address_is_required: "IP Address is required",
    IP_Address_is_not_valid: "IP Address is not valid",
    Are_you_sure_you_want_to_delete_this_IP: "Are you sure you want to delete this IP?",
    Web_Punch: "Web Punch",
    IP: "IP",
    Do_you_want_to_add_this_punch_at_xtime: "Do you want to add this punch at {0}?",
    Leave_Information: "Leave Information",
    Submit_Leave: "Submit Leave",
    Available: "Available",
    Leave_Requests: "Leave Requests",
    Enable_Employee_Approve_Timecard: "Employee Approve Timecard",
    Are_you_sure_you_want_to_close_payroll_hierarchy_before_lock_with_leave:
        "Are you sure you want to close payroll hierarchy? Closing payroll will lock the unlocked payroll hierarchy for this pay period, and will trigger accrual calculations for the closed pay period, as well as add all approved time off requests to timecards for this pay period. All unapproved time off requests will automatically be rejected. Accrual calculations cannot be undone.",
    Are_you_sure_you_want_to_close_payroll_hierarchies_before_lock_with_leave:
        "Are you sure you want to close {0} payroll hierarchies? Closing payroll will lock the unlocked payroll hierarchies for this pay period, and will trigger accrual calculations for the closed pay period, as well as add all approved time off requests to timecards for this pay period. All unapproved time off requests will automatically be rejected. Accrual calculations cannot be undone.",
    EMP_Approved: "E.Approved",
    Hierarchy_not_found_for_IP: "Hierarchy not found for IP: {0}",
    IP_Address_is_duplicated: "IP Address is duplicated",
    SSO_LOGIN_IN_PROGRESS: "SSO Login in Progress",
    Clone_x_Shifts: "Clone {0} Shifts",
    Shifts_cloned_successfully: "Shifts cloned successfully",
    DefferedImageUploadTitle: "Image Not Uploaded",
    DefferedImageUploadBody: "Upload in progress from mobile device",
    List_View: "List View",
    Calendar_View: "Calendar View",
    Deny: "Deny",
    Holiday_Templates: "Holiday Templates",
    Add_Holiday_Template: "Add Holiday Template",
    Edit_Holiday_Template: "Edit Holiday Template",
    Delete_Holiday_Template: "Delete Holiday Template",
    Holiday_Template_created_successfully: "Holiday Template created successfully",
    Holiday_Template_updated_successfully: "Holiday Template updated successfully",
    Are_you_sure_delete_holiday_template: "Are you sure you want to delete this holiday template?",
    Holiday_Template_name_is_duplicated: "Holiday Template name is duplicated",
    Holiday_Template_removed_successfully: "Holiday Template removed successfully",
    Holiday_Template_Selected: "Holiday Template Selected",
    No_Holiday_Template: "No Holiday Template",
    This_date_exists_already: "This date exists already",
    Add_Holiday: "Add Holiday",
    Holidays: "Holidays",
    Holiday_Template: "Holiday Template",
    Holiday_Template_Select_Note: "Note: All date changes to the {0} Holiday template will automatically be reflected in this pay group holiday instance.",
    Holiday_Pay_Type: "Holiday Pay Type",
    The_HoursPerDay_of_holiday_is_more_than_the_MaximumPunchSetLength: "The HoursPerDay of {0} holiday is more than the MaximumPunchSetLength.",
    Are_you_sure_you_want_to_approve_leave_request_of_employee: "Are you sure you want to approve a leave request of employee '{0}' for {1}?",
    Are_you_sure_you_want_to_deny_leave_request_of_employee: "Are you sure you want to deny a leave request of employee '{0}' for {1}?",
    Are_you_sure_you_want_to_delete_leave_request_of_employee: "Are you sure you want to delete a leave request of employee '{0}' for {1}?",
    Also_remove_employee_self_service: "Also remove employee self service",
    Are_you_sure_you_want_to_delete_the_selected_account_user_with_below_option: "Are you sure you want to delete the selected account user(s) with the below option?",
    Schedule_Validation_Issues: "Schedule Validation Issues",
    Employee_Already_Scheduled: "Employee Already Scheduled",
    Shift_Confilicts_with_Time_Off: "Shift Confilicts with Time Off",
    Auto_Assign_Employees_to_Schedule: "Auto-Assign Employees to Schedule",
    Auto_Assign: "Auto-Assign",
    Auto_Assign_Confirm_Dialog_Body: "Confirm you would like to auto-assign employees to schedule based on employee availability, employee hierarchy, and position assignments?",
    Schedule_auto_assign_has_completed: "Schedule auto-assign has completed. All possible assignments have been made.",
    Exception_Setting: "Exception Setting",
    Minutes_To_Trigger_Missing_PunchIn_Exception: "Minutes To Trigger Missing PunchIn Exception",
    Minutes_To_Trigger_Early_PunchIn_Exception: "Minutes To Trigger Early PunchIn Exception",
    Minutes_To_Trigger_Late_PunchIn_Exception: "Minutes To Trigger Late PunchIn Exception",
    Minutes_To_Trigger_Early_PunchOut_Exception: "Minutes To Trigger Early PunchOut Exception",
    Minutes_To_Trigger_Late_PunchOut_Exception: "Minutes To Trigger Late PunchOut Exception",
    Enable_Missing_Break_Exception: "Enable Missing Break Exception",
    Minutes_To_Trigger_Long_Break_Exception: "Minutes To Trigger Long Break Exception",
    Enable_No_Shift_Exception: "Enable No Shift Exception",
    Missed: "Missed",
    Early: "Early",
    Late: "Late",
    Long: "Long",
    Break: "Break",
    Exception_Filters: "Exception Filters",
    Missing_Punches: "Missing Punches",
    Emp_Approval: "Emp Approval",
    Sup_Approval: "Sup Approval",
    Missing_In_Punch: "Missing In Punch",
    Early_In: "Early In",
    Late_In: "Late In",
    Early_Out: "Early Out",
    Late_Out: "Late Out",
    Long_Break: "Long Break",
    Missed_Break: "Missed Break",
    No_Shift: "No Shift",
    From: "From",
    To: "To",
    Sunday_ShortTerm: "Sun",
    Monday_ShortTerm: "Mon",
    Tuesday_ShortTerm: "Tue",
    Wednesday_ShortTerm: "Wed",
    Thursday_ShortTerm: "Thu",
    Friday_ShortTerm: "Fri",
    Saturday_ShortTerm: "Sat",
    The_Qty_must_be_less_than_or_equal_to_x: "The Qty must be less than or equal to {0}",
    Shift_unassigned_successfully: "Shift unassigned successfully",
    Schedule_name_is_duplicated_for_this_week: "Schedule name is duplicated for this week",
    Copy_Schedule: "Copy Schedule",
    Schedule_copied_successfully: "Schedule copied successfully.",
    Notification_Settings: "Notification Settings",
    Personal_Notification_Preferences: "Personal Notification Preferences",
    Subscription_Notifications: "Subscription Notifications",
    Personal_Notifications: "Personal Notifications",
    Email_Notifications: "Email Notifications",
    Inapp_Push_Notifications: "In-app Push Notifications",
    Are_you_sure_you_want_to_delete_the_selected_notification: "Are you sure you want to delete the selected notification?",
    No_Notification: "No Notification",
    Notification: "Notification",
    Notify_Method: "Notify Method",
    Schedule_Reminder: "Schedule Reminder",
    Missing_Out_Punch: "Missing Out Punch",
    Push: "Push",
    Email: "Email",
    SMS: "SMS",
    Voice: "Voice",
    Add_Notification: "Add Notification",
    Edit_Notification: "Edit Notification",
    Notification_Type: "Notification Type",
    Notification_Selected: "Notification Selected",
    Subscription_Selected: "Subscription Selected",
    Are_you_sure_you_want_to_delete_the_selected_subscriptions: "Are you sure you want to delete the selected subscriptions?",
    No_Subscription: "No Subscription",
    Add_Subscription: "Add Subscription",
    Edit_Subscription: "Edit Subscription",
    Missing_Punch: "Missing Punch",
    Missing_Employee_Approval: "Missing Employee Approval",
    Missing_Supervisor_Approval: "Missing Supervisor Approval",
    Early_In_Punch: "Early In Punch",
    Early_Out_Punch: "Early Out Punch",
    Late_In_Punch: "Late In Punch",
    Late_Out_Punch: "Late Out Punch",
    Missing_Break: "Missing Break",
    Exception_Type: "Exception Type",
    Direct_Reports_Only: "Direct Report Only",
    Subscriptions: "Subscriptions",
    Include_Child_Hierarchies: "Include Child Hierarchies",
    Requested: "Requested",
    Cannot_delete_leave_request_punch: "Cannot delete punchset. This is tied to a leave request and all changes must be made to the time off request",
    Cannot_update_leave_request_punch: "Cannot update punchset. This is tied to a leave request and all changes must be made to the time off request",
    Not_enough_hours_available_to_make_this_leave_request: "Not enough hours available to make this leave request.",
    Min_Balance: "Min Balance",
    Max_Balance: "Max Balance",
    Time_off: "Time off",
    App: "App",
    Add_Notify_Method: "Add Notify Method",
    Leave_Request_exist_for_selected_period: "Leave Request exist for selected period.",
    This_Notification_is_duplicated: "This Notification is duplicated.",
    This_Subscription_is_duplicated: "This Subscription is duplicated.",
    Request: "Request",
    Allow_Punch_From_Personal_Device: "Allow Punch From Personal Device",
    Min_Hours_Per_Day: "Min Hours Per Day",
    Max_Hours_Per_Day: "Max Hours Per Day",
    Max_Hours_Per_Day_should_be_greater_than_Min_Hours_Per_Day: "Max Hours Per Day should be greater than Min Hours Per Day",
    Invalid_supervisor: "Invalid supervisor",
    Inactive: "Inactive",
    Active_Status: "Active Status",
    Cannot_delete_shifts_already_in_use: "Cannot delete shifts already in use.",
    Sched_In: "Sched In",
    Sched_Out: "Sched Out",
    Work_Preferences: "Work Preferences",
    Preferred: "Preferred",
    Unavailable: "Unavailable",
    No_preference_found: "No preference found!",
    Preference_Selected: "1 Preference Selected",
    x_Preference_Selected: "{0} Preferences Selected",
    Are_you_sure_you_want_to_delete_selected_preference: "Are you sure you want to delete selected preference(s)?",
    Edit_Work_Preference: "Edit Work Preference",
    New_Work_Preference: "New Work Preference",
    Work_Preference_is_not_allowed_for_past_and_current_date: "Work Preference is not allowed for past and current date.",
    Confirm_Assigned_Employee_Constraints: "Confirm Assigned Employee Constraints",
    Abbreviation_Work: "Work",
    Abbreviation_Preference: "Pref",
    Employee_does_not_have_access_to_the_punch_level_of_shift: "Employee does not have access to the punch level of shift",
    Shift_conflicts_with_employee_work_preferences: "Shift conflicts with employee’s work preferences",
    Leave_request_should_not_be_created_with_a_date_that_is_before_the_prohibition_end_date: "Leave request should not be created with a date that is before the prohibition end date",
    Employee_pay_group_does_not_contain_the_shift_paytype: "Employee pay group does not contain the shift paytype",
    Employee_pay_group_does_not_contain_the_break_paytype: "Employee pay group does not contain the break paytype",
    Abbreviation_EMP_Approved: "E.Appro",
    Abbreviation_Supervisor_Approved: "S.Appro",
    Search_Location: "Search Location",
    Punch_added_GPS_off: "Punch added GPS off",
    Schedule_Period_Days: "Schedule Period Days",
    Period_Days: "Days",
    Seven_Day_List: "7 Day / List",
    Seven_Day_View: "7 Day View",
    Day_X: "Day {0}",
    Schedule_Start_Date: "Schedule Start Date",
    Week: "Week",
    Days: "Days",
    View_Type: "View Type",
    Assigned_Employee: "Assigned Employee",
    No_Note: "No Note",
    Device_Admin_Pin: "Device Admin Pin",
    Changing_the_employee_hierarchy_may_impact_assigned_shifts_Would_you_like_to_proceed: "Changing the employee's hierarchy may impact assigned shifts. Would you like to proceed?",
    This_PayType_is_invalid: "This PayType is invalid",
    Code: "Code",
    Input_Name: "Input Name",
    Input_Code: "Input Code",
    Invalid_for_used_hierarchy_or_employee_paygroup: "Invalid for used hierarchy or employee paygroup",
    Its_not_valid_for_pay_group: "It's not valid for pay group",
    Its_not_valid_for_pay_group_used_employee: "It's not valid for pay group of used employee",
    Linked: "Linked",
    The_PayType_of_holiday_is_invalid: "The PayType of {0} holiday is invalid",
    Cannot_delete_holiday_template: "Cannot delete this holiday template, because it is used for paygroup",
    Shift_Confilicts_with_holiday: "Shift conflicts with holiday",
    Enable_Mobile_Location_Fraud_Prevention: "Enable Mobile Location Fraud Prevention",
    Days_To_Trigger_Missing_Employee_Approval: "Days To Trigger Missing Employee Approval",
    Days_To_Trigger_Missing_Supervisor_Approval: "Days To Trigger Missing Supervisor Approval",
    Name_is_duplicated: "Name is duplicated",
    Holiday: "Holiday",
    Cannot_punch_for_locked_pay_period: "Cannot punch for locked pay period",
    Duplicated_date_exist_for_pay_group: "Duplicated date exist for pay group",
    Cannot_delete_denied_leave_request: "Cannot delete denied leave request(s)",
    Cannot_delete_approved_leave_request: "Cannot delete approved leave request(s)",
    Cannot_delete_approved_leave_request_for_locked_period: "Cannot delete approved leave request(s) for locked period",
    Leave_request_deleted_successfully: "Leave request(s) deleted successfully",
    Cannot_approve_leave_request_for_locked_period: "Cannot approve leave request(s) for locked period",
    Cannot_deny_leave_request_for_locked_period: "Cannot deny leave request(s) for locked period",
    Allow_Punches: "Allow Punches",
    Disable_Message: "Disable Message",
    Punches_are_not_allowed_at_this_location: "Punches are not allowed at this location",
    Workday_Start_Time: "Workday Start Time",
    Enable_Clients: "Enable Clients",
    Enable_Jobs: "Enable Jobs",
    No_job_found: "No job found",
    No_client_found: "No client found",
    Jobs: "Jobs",
    Clients: "Clients",
    Parent_Hierarchy: "Parent Hierarchy",
    Phases: "Phases",
    Job_Details: "Job Details",
    Job_Name: "Job Name",
    Job_Id: "Job Id",
    Job_Start_End_Date: "Use Start End Dates",
    Occupations: "Occupations",
    Specialties: "Specialties",
    Badges: "Badges",
    Choose_Occupations: "Choose Occupations",
    Choose_Specialties: "Choose Specialties",
    Choose_Badges: "Choose Badges",
    Cost_Code: "Cost Code",
    No_phase_found: "No phase found",
    Choose_Job: "Choose Job",
    Choose_Phase: "Choose Phase",
    Job: "Job",
    Phase: "Phase",
    Client_Details: "Client Details",
    Client_Name: "Client Name",
    logo: "Logo",
    Client_Id: "Client Id",
    Primary_Contact: "Primary Contact",
    No_Primary_Contact: "No Primary Contact",
    Billing_Contact: "Billing Contact",
    No_Billing_Contact: "No Billing Contact",
    Referral_Source: "Referral Source",
    Referred_By: "Referred By",
    Created_By: "Created By",
    Modified: "Modified",
    Modified_By: "Modified By",
    Last_Login: "Last Login",
    Contacts: "Contacts",
    Primary: "Primary",
    Add_Contact: "Add Contact",
    Contact_Selected: "1 Contact Selected",
    x_Contact_Selected: "{0} Contact Selected",
    My_Candidate_ShortList: "My Candidate Short List",
    WorkPool_Employee_Selected: "1 WorkPool Employee Selected",
    x_WorkPool_Employee_Selected: "{0} WorkPool Employee Selected",
    No_ShortList_Candidate_Found: "No Short List Candidate Found!",
    Add_To_Shortlist: "Add To Shortlist",
    Submitted_Candidates: "Proposed Candidates",
    No_Submitted_Candidate_Found: "No Proposed Candidate Found!",
    Candidate_Requested: "Candidate Requested",
    No_Requested_Candidate_Found: "No Requested Candidate Found!",
    Auto_Matched_Candidates: "Auto Matched Candidates",
    No_Auto_Matched_Candidate_Found: "No Auto Matched Candidate Found!",
    Missing_Badges: "Missing Badges",
    Miles: "Miles",
    Scheduled_Hours: "Scheduled Hours",
    Double_Shift: "Double Shift",
    Archive: "Archive",
    Messages: "Messages",
    Submitted_By: "Submitted By",
    Show_Archived: "Show Archived",
    None: "None",
    Delete_Contact: "Delete Contact",
    Confirm_delete_contact: "Are you sure you want to delete the selected 'Contact(s)'?",
    No_contact_found: "No contact found!",
    Phone: "Phone",
    Title: "Title",
    Profile_Picture: "Profile Picture",
    Preferred_Name: "Preferred Name",
    Preferred_Contact_Method: "Preferred Contact Method",
    Home_Phone: "Home Phone",
    Work_Phone: "Work Phone",
    Cell_Phone: "Cell Phone",
    Primary_Email: "Primary Email",
    Select_Profile_Picture: "Select Profile Picture",
    Unselect_Profile_Picture: "Unselect Profile Picture",
    Upload_Logo: "Upload Logo",
    Remove_Logo: "Remove Logo",
    Add_New_Note: "Add New Note",
    Enter_First_Note: "Click the add button to enter your first note!",
    No_Audits: "No Audits",
    No_Match_Filter: "No Notes match the filter.",
    No_Search_Result: "No Notes match the search criteria.",
    See_More: "See More",
    Created: "Created",
    Communications: "Communications",
    Street: "Street",
    State: "State",
    Today_Hours: "Today Hours",
    This_Week_Hours: "Hours This Week",
    Job_Location: "Job Location",
    Default_Job: "Default Job",
    Default_Phase: "Default Phase",
    Active_Clocks: "Active Clocks",
    Clocks: "Clocks",
    Monthly_Bill: "Monthly Bill",
    Billing_Detail: "Billing Detail",
    Hierarchy_is_Deleted: "Hierarchy is Deleted",
    Worker_Pool: "Worker Pool",
    Contact_Name: "Contact Name",
    Contact_Email: "Contact Email",
    Active_Employee_Devices: "Active Employee Devices",
    Active_Clock_Devices: "Active Clock Devices",
    Per_Employee_Month: "Per Employee / Month",
    Per_Clock_Month: "Per Clock / Month",
    Active_Employees: "Active Employees",
    Require_Agreement_Before_Training_Punching: "Require Agreement Before Training/Punching",
    Daily_Punch_Rule: "Daily Punch Rule",
    Agreement_Text: "Agreement Text",
    Create: "Create",
    Are_you_sure_you_want_to_create_new_version_agreement: "Are you sure you want to create new version agreement? This will require all users to accept the new agreement.",
    Findd_biometric_agreement_accepted_on: "Findd biometric agreement accepted on {0}",
    Findd_biometric_agreement_not_accepted: "Findd biometric agreement not accepted",
    Client_employee_agreement_accepted_on: "Client employee agreement accepted on {0}",
    Client_employee_agreement_not_accepted: "Client employee agreement not accepted",
    Override_hierarchy: "Override hierarchy",
    Schedule_Ranking: "Schedule Ranking",
    os: "OS",
    App_Version: "App Version",
    Connected: "Connected",
    Not_Connected: "Not Connected",
    None_exist: "None exist",
    Allow_GPS_Locations: "Allow GPS Locations",
    Allow_MicroLocations: "Allow MicroLocations",
    Allow_Positions: "Allow Positions",
    Allow_Attached_Employees: "Allow Attached Employees",
    Allow_Attached_Users: "Allow Attached Users",
    Add_New_Hierarchy_Definition: "Add New Hierarchy Definition",
    Level_Label: "Level Label",
    Label_length_cannot_exceed_50_characters: "Label length cannot exceed 50 characters",
    Successfully_added: "Successfully added",
    Hour: "Hour",
    Rank: "Rank",
    Hierarchy_Removed: "Hierarchy Removed",
    Supervisor_cannot_approve_his_own_timecard: "Supervisor cannot approve his own timecard",
    Supervisor_cannot_unapprove_his_own_timecard: "Supervisor cannot unapprove his own timecard",
    Warning_your_timecard_will_not_approve: "Warning: If your timecard is included, it will not be approved",
    Warning_your_timecard_will_not_unapprove: "Warning: If your timecard is included, it will not be unapproved",
    Split_Punches_by_Day_Boundary: "Split Punches by Day Boundary",
    Enable_Punch_Split_At_Day_Boundary: "Enable Punch Split At Day Boundary",
    Enable_Work_Availability: "Enable Work Availability",
    Scheduled: "Scheduled",
    Worked: "Worked",
    Worked_and_Scheduled: "Worked and Scheduled",
    Copy_Schedule_Validation_Issues: "Copy Schedule Validation Issues",
    Cannot_copy_schedule_with_duplicated_name: "Cannot copy schedule with duplicated name",
    Warning: "Warning",
    Are_you_sure_you_want_to_copy_schedule_once_unassign_shift_had_conflict: "Are you sure you want to copy schedule once unassign shift had conflict",
    Schedule_name_is_duplicated: "Schedule name is duplicated",
    Available_Days: "Available Days",
    All_Days: "All Days",
    Cannot_update_auto_created_split_punch: "Cannot update auto created split punch",
    Cannot_delete_auto_created_split_punch: "Cannot delete auto created split punch",
    Custom_Overtime: "Custom Overtime",
    Overtime_Rules: "Overtime Rules",
    Add_Overtime_Rule: "Add Overtime Rule",
    Edit_Overtime_Rule: "Edit Overtime Rule",
    Daily: "Daily",
    ConsecutiveDay: "Consecutive Day",
    Overtime_Rule_Type: "Overtime Rule Type",
    Overtime_PayType_Priority: "Overtime Paytype Priority",
    Overtime_Hour_Threshold: "Overtime Hour Threshold",
    Overtime_PayType: "Overtime PayType",
    Enable_Double_Overtime: "Enable Double Overtime",
    Double_Overtime_Hour_Threshold: "Double Overtime Hour Threshold",
    Double_Overtime_PayType: "Double Overtime PayType",
    Days_Worked_To_Trigger_Overtime: "Days Worked To Trigger Overtime",
    DoubleOvertimeHourThreshold_should_be_greater_than_OvertimeHourThreshold: "It should be greater than OT",
    Filter_By_Punch_Hierarchy: "Filter By Punch Hierarchy",
    Enable_Create_Empty_Timecard: "Enable Create Empty Timecard",
    Delete_Selected_Position: "Delete Selected Position(s)",
    Are_you_sure_you_want_to_delete_the_selected_position: "Are you sure you want to delete the selected position(s)",
    Integration: "Integration",
    ScheduledJobs: "Scheduled Jobs",
    Export_To_Third_Party: "Export To Third Party",
    Supported_file_types: "Supported file types",
    This_file_format_is_not_supported: "This file format is not supported",
    Maximum_File_Size: "Maximum File Size",
    This_file_size_is_too_large: "This file size is too large",
    Punch_Details: "Punch Details",
    Require_Punch_Pre_Screen_Questions: "Require Punch Pre-Screen Questions",
    PreQuestionNote1: 'Note: All questions should be yes or no questions. Questions require a "NO" answer.',
    PreQuestionNote2: 'Any "YES" answer will prevent punching and create a "Pre-Question" exception.',
    Introduction_Page_Message_Lang: "Introduction Page Message {0}",
    Question_Num: "Question {0} {1}",
    Punch_Questions_for_x: "Punch Questions for {0}",
    Question_Exception: "Question Exception",
    Quest_Fail: "Quest Fail",
    Punch: "Punch",
    Screening: "Screening",
    Limit_To_Shift_Hierarchy: "Limit To Shift Hierarchy",
    Invalid_registration_code_format: "Invalid registration code format",
    Failed_to_update_device: "Failed to update device",
    Registration_code_used_already: "Registration code used already",
    Device_registered_successfully: "Device registered successfully",
    Are_you_sure_you_want_to_export_to_third_party: "Are you sure you want to export to third party?",
    Estimated_Time_Report: "Estimated Time Report",
    In_Out_Report: "In/Out Report",
    Are_you_sure_you_want_to_download_the_In_Out_Report: "Are you sure you want to download the In/Out Report?",
    Are_you_sure_you_want_to_download_the_Estimated_Time_Report_for_selected_option: "Are you sure you want to download the Estimated Time Report for selected option?",
    Estimated_Time_Report_Type: "Estimated Time Report Type",
    Restrict_To_Dates: "Restrict To Dates",
    Download_PDF: "Download PDF",
    Add_Job: "Add Job",
    Add_Punch_Rule: "Add Punch Rule",
    Punch_Rule: "Punch Rule",
    Add_Client: "Add Client",
    Job_ID_is_duplicated: "Job ID is duplicated",
    Cost_Code_is_duplicated: "Cost Code is duplicated",
    Cost_Center_is_duplicated: "Cost Center is duplicated",
    Punch_hierarchy_is_invalid: "Punch hierarchy is invalid",
    Punches_are_not_allowed_at_Account_level: "Punches are not allowed at Account level",
    Master_schedule: "Master Schedule",
    Master_Schedules: "Master Schedules",
    Schedule_removed_successfully: "Schedule(s) removed successfully",
    Next_Post_Date: "Next Post Date",
    Add_New_Master_Schedule: "Add New Master Schedule",
    Master_Schedule_Active: "Master Schedule Active",
    Post_Schedules_In_Advance_Days: "Post Schedules In Advance (Days)",
    Copy_Schedule_to: "Copy Schedule to",
    Schedule_Report: "Schedule Report",
    Template: "Template",
    Select_Template: "Select Template",
    Template_from: "Template from",
    Allow_Job: "Allow Job",
    Warning_If_you_dont_input_an_Agreement_it_will_be_off: "Warning: If you don't input an Agreement, it will be off",
    Successfully_created: "Successfully created",
    Move: "Move",
    old_data_saving_error: "Error, Something went wrong. You may have old data. Please refresh and try again.",
    the_endpoint_has_not_ticks: "Error, The endpoint has not ticks. Please contact support.",
    Default_Punch_Job: "Default Punch Job",
    Default_Punch_Phase: "Default Punch Phase",
    Default_cannot_be_outside_the_Punch_Permission_Hierarchy: "Default cannot be outside the Punch Permission Hierarchy.",
    Organization_Hierarchy: "Organization Hierarchy",
    Punch_Default_Settings: "Punch Default Settings",
    Schedule_Payroll_Settings: "Schedule & Payroll Settings",
    Field: "Field",
    User_Policy: "User Policy",
    Hire_Date: "Hire Date",
    Exempt: "Exempt",
    User_Information: "User Information",
    User_Agency: "Agency",
    No_Hire_Date: "No Hire Date",
    Termination_Date: "Termination Date",
    No_Termination_Date: "No Termination Date",
    Latest_rehire_Date: "Latest Rehire Date",
    No_Rehire_Date: "No Rehire Date",
    Punch_Permission_Hierarchy: "Punch Permission Hierarchy",
    Punch_Audit_Records: "Punch Audit Records",
    Punch_Perm_Hierarchy: "Punch Perm Hierarchy",
    Punch_Hierarchy: "Punch Hierarchy",
    Are_you_sure_you_want_to_remove_current_Hierarchy_Item_from_selected_Employee: "Are you sure you want to remove current Hierarchy Item from selected Employee(s)?",
    Enable_Phases: "Enable Phases",
    Enable_CWM: "Enable CWM",
    Enabled: "Enabled",
    Expenses: "Expenses",
    One_Time_Expense: "One Time Expense Template",
    Recurring_Expense: "Recurring Expenses Template",
    No_Expense_Found: "No Expense Found",
    Frequency: "Frequency",
    Frequency_Description: "Expense will be applied to first shift of the specified frequency. For example, the first shift of the week will have the expense applied to it if Weekly is selected",
    Pick_a_date: "Pick a date",
    User_Match_Filter: "User Match Filter",
    Require_Occupation: "Require Occupation Match",
    Require_Speciality: "Require Specialty Match",
    Require_Badge_Match: "Require Badge Match",
    Require_Complete_Badge: "Require Badge To Complete",
    Allow_Partial_Badge: "Allowed Partially Completed Badge",
    Match_User_Status: "Match By User Status",
    Select_Status: "Select Status",
    Substatus: "Substatus",
    Filter_Name: "Filter Name",
    No_Badge_Found: "No Badge found!",
    No_Specialty_Found: "No Specialty found!",
    No_Occupation_Found: "No Occupation found!",
    Requested_Jobs: "Requested Jobs",
    No_Requested_Jobs_Found: "No Requested Jobs Found",
    Show_Inactive: "Show Inactive",
    Accrual_Adjustment_Rules: "Accrual Adjustment Rules",
    Require_Adjustment_Note: "Require Adjustment Note",
    Require_Adjustment_Reason: "Require Adjustment Reason",
    Adjustments: "Adjustments",
    Adjustment: "Adjustment",
    No_Adjustment_Found: "No Adjustment Found!",
    Allow_Manual_Adjustment: "Allow Manual Adjustment",
    Adjustment_Value: "Adjustment Value",
    Add_Accrual_Adjustment: "Add Accrual Adjustment",
    Edit_Accrual_Adjustment: "Edit Accrual Adjustment",
    Manual_Accrual_Adjustment: "Manual Accrual Adjustment",
    Adjustment_Reason: "Adjustment Reason",
    Current_Value: "Current Value",
    Enable_Manual_Accrual_Adjustment: "Enable Manual Accrual Adjustment",
    Confirm_delete_adjustment: "Are you sure you want to delete the selected 'Adjustment(s)'?",
    Adjustment_Selected: "1 Adjustment Selected",
    x_Adjustment_Selected: "{0} Adjustment Selected",
    Current_selected_date_range_is_outside_of_the_Job_date_range: "Current selected date range is outside of the Job's date range",
    Current_selected_day_is_outside_of_the_Job_date_range: "Current selected day is outside of the Job's date range",
    One_job_can_be_assigned: "Can not assign more than one job when employee is selected",
    Employee_can_not_be_selected: "Can not select employee when more than one shifts are assigned",
    Client_Type: "Client Type",
    Choose_client_type: "Choose Client Type",
    No_client_type_found: "No Client Type Found",
    Mass_Shift_Edit: "Mass Shift Edit",
    Mass_Edit: "Mass Edit",
    x_Editing_Mass_Shifts: "You are editing {0} Jobs/Shifts. You can edit active status, start time, end time, custom job status and notes",
    x_Editing_Mass_Shifts_For_CRM_Disabled: "You are editing {0} Job(s). You can edit active status and notes",
    Edit_Shift_Start_Time: "Edit Shift Start Time",
    Edit_Shift_End_Time: "Edit Shift End Time",
    Add_Note: "Add Note",
    New_Start_Time: "New Start Time",
    New_End_Time: "New End Time",
    Edit_Job_Status: "Edit Custom Job Status",
    Edit_Job_Active_Status: "Edit Job Active Status",
    Review_Changes: "Review Changes",
    Confirm_Changes: "Confirm Changes",
    Client_Jobs_Report: "Client Jobs Report",
    Auto_Assign_Shift: "Auto Assign Shift",
    Confirmed_Work: "Confirmed Work",
    Distance_To_Job: "Distance To Job",
    Shift_Edit_Error_Message: "Can't be edited because selected Job(s) has multiple shifts",
    HR: "HR",
    TLM: "TLM",
    Successfully_archived: "Successfully Archived!",
    Successfully_shortlisted: "Successfully Shortlisted!",
    Successfully_assigned: "Successfully Assigned!",
    Assign_Employee: "Assign Employee",
    Oepn_Detail_In_New_Tab: "Open detail in new tab",
    Filter_Only_Worker_Pool: "Filter Only Worker Pool",
    Guaranteed_Minimum: "Guaranteed Minimum",
    Meal_Penalty_Waiver: "Meal Penalty Waiver",
    Bonus_Pay: "Bonus Pay",
    Full_Timecard_Punch_Rules: "Full Timecard Punch Rules",
    Incorrect_CSV_File: "Incorrect CSV file! Please upload correct one.",
    Expand_All_Timecards: "Expand All Timecards",
    Collpase_All_Timecards: "Collapse All Timecards",
    CannotUpdateTimecardAllowModifications: "Cannot Update Timecard Allow Modifications",
    Time_Of_Punch: "Time of Punch",
    Time_Of_Punch_Upload: "Time of Punch Upload",
    Exported_Successfully: "Exported Successfully!",
    Export: "Export",
    Filter_Template: "Filter Template",
    Filter_Saved: "Filter Saved!",
    Filter_Updated: "Filter Updated!",
    Filter_Deleted: "Filter Deleted!",
    Delete_Filter: "Delete Filter",
    Employee_Details: "Employee Details",
    Exmpet_Employee: "Exempt Employee",
    Self_Service_Login_Enabled: "Self-Service Login Enabled",
    Employee_Default_Hierarchy: "Employee Default Hierarchy",
    Click_To_Select_Job: "Click To Select Job",
    Supervisors: "Supervisors",
    This_name_is_not_allowed: "This name is not allowed",
    Save_Filter: "Save Filter",
    Edit_Employee_Filter: "Edit Employee Filter",
    Create_New_Employee_Filter: "Create New Employee Filter",
    Create_Filter_Template_Title_Intro: "Create a saved filter for easy searching! Name this filter, select the parameters and click Save. You can always edit this filter, even after saving.",
    Edit_Filter_Template_Title_Intro: 'Edit details for this custom filter and click "Save Filter" below for the changes to take effect.',
    Filter_with_this_name_already_exist: "Filter with this name already exist",
    Define_Retro_Pay_Code: "Define Retro Pay Type",
    Retro_Pay_Type_Code: "Retro Pay Type",
    Export_Diff_Timecard: "Export Timecard Changes",
    Export_Diff_Disclaimer:
        "Timecard differences can be exported to future pay periods. Select a future pay period and the changes will be placed on the user’s timecard in the corresponding pay period.",
    Export_pay_period_should_be_future_from_timecard_pay_period: "Export pay period should be future from timecard pay period",
    Failed_Export_Timecard_Diff: "Failed Export Timecard Diff",
    The_timecard_export_is_only_allowed_in_future_unlocked_pay_periods:
        "The timecard export is only allowed in future unlocked pay periods. \nPlease check that the destination pay period is in the future and has not yet been locked.",
    Exporting_Diff_Timecard_Reason: "Prior Period Change Reason",
    Exporting_Diff_Timecard_Reason_Required: "Reason is required",
    ReExport: "Re-Export",
    View_Custom_Employee_Fields: "View Custom Employee Fields",
    Edit_Custom_Employee_Fields: "Edit Custom Employee Fields",
    Edit_Custom_Job_Fields: "Edit Custom Job Fields",
    Custom_Field: "Custom Field",
    Change_Made_By_GlobalAdmin: "Change made by Global Admin",
    Allow_Client_Selection_Edit: "Allow Client Selection Edit",
    View_Jobs: "View Jobs",
    Add_Jobs: "Add Jobs",
    Edit_Jobs: "Edit Jobs",
    Delete_Jobs: "Delete Jobs",
    View_Clients: "View Clients",
    Add_Clients: "Add Clients",
    Edit_Clients: "Edit Clients",
    Delete_Clients: "Delete Clients",
    Edit_Custom_Client_Fields: "Edit Custom Client Fields",
    Job_Field: "Job Field",
    Phase_Field: "Phase Field",
    Employee_Field: "Employee Field",
    Client_Field: "Client Field",
    Application_Of_Auto_Break: "Application of Auto Break",
    Auto_Break_Tooltip_Heading_Info_Text: "This setting determines how the auto break will be applied.",
    Auto_Break_Tooltip_Based_On_Punch_Info_Text:
        "If this is set up at a hierarchy item, the employee will need to punch at this hierarchy item or one below, or at a job attached to this hierarchy item in order for the Auto Break to apply.",
    Auto_Break_Tooltip_Employee_Default_Hierarchy_Info_Text:
        "If this is set up at a hierarchy item, employee's with this hierarchy item as their Default Hierarchy will always get this auto break, no matter where they punch in the hierarchy (provided the auto break requirements are met).",
    Show_Consolidated_Timecard_View: "Show Consolidated Timecard View",
    AveragePayRate: "Average rate based on total time logged for paytype",
    OvertimeFactor: "OT Factor",
    DoubleOvertimeFactor: "OT2 Factor",
    Budget: "Budget",
    No_weekly_job_budget_items_found: "No weekly job budget items found",
    WeeklyHourlyBudget: "Weekly Hourly Budget",
    WeeklyAmountBudget: "Weekly Amount Budget",
    NewJobBudgetItem: "New Job Budget Item",
    EditJobBudgetItem: "Edit Job Budget Item",
    RegularTimeLabel: "REG",
    OvertimeLabel: "OT",
    DoubleOvertimeLabel: "OT2",
    BudgetedHours: "Budgeted Hours",
    VarianceHours: "Variance Hours",
    BudgetedAmount: "Budgeted Amount",
    VarianceAmount: "Variance Amount",
    Are_you_sure_you_want_to_delete_selected_budgets: "Are you sure you want to deleted the selected budget items?",
    Budget_Selected: "Budget Item Selected",
    x_Budgets_Selected: "{0} Budget Items Selected",
    Account_PEPM: "Account PEPM",
    Six_Minute_Rounding_Rule: "6 Minute Rounding Rule",
    One_Minute_Rounding_Rule: "1 Minute Rounding Rule",
    Add_New_Account: "Add New Account",
    Save_Account: "Save Account",
    Loading_Account_Details: "Loading Account Details",
    Open_Account: "Open Account",
    Next: "Next",
    Previous: "Previous",
    SendWelcomeEmail: "Send User Welcome Email",
    AccountOwner: "Account Owner",
    AccountOwnerFirstName: "Account Owner First Name",
    AccountOwnerLastName: "Account Owner Last Name",
    AccountOwnerEmail: "Account Owner Email",
    AccountName: "Account Name",
    Finish: "Finish",
    AccountActivity: "Account Activity",
    AccountSubscriptionOverview: "Subscription Overview",
    AccountBillingHistory: "Billing History",
    RecentInvoices: "Recent Invoices",
    AccountBillingContact: "Billing Contact",
    AccountPaymentMethod: "Payment Method",
    Are_You_Sure_You_Want_To_Remove_This_Payment_Method: "Are you sure you want to remove this payment method?",
    RemoveCard: "Remove Card",
    AddPaymentMethod: "+ Add Payment Method",
    Future_payments_will_use_this_card: "Future payments will use this card.",
    DueDate: "Due Date",
    PaymentMethodMustBeSetup: "A payment method must be setup before you can upgrade the plan from the free version. Click on the 'Payment Method' tab to add a credit card to your account.",
    UpgradeToProfessionalPrompt: "Are you sure you want to upgrade to Professional?",
    Upgrade: "Upgrade",
    TalkToSales: "Talk to Sales",
    SelectedPlan: "Selected Plan",
    PerEmployee: "Per Employee",
    Column_Selector_One_Column_Error_Message_Text: "Cannot hide all columns. Atleast one column should be shown in table!",
    Additional_Filter_Parameter: "Additional Filter Parameter",
    Add_Filter_Parameter: "Add Filter Parameter",
    Edit_Filter_Parameter: "Edit Filter Parameter",
    Add_Filter_Parameter_Text1: "Filter employees who have the",
    Add_Filter_Parameter_Text2: "toggle set to",
    ON: "ON",
    OFF: "OFF",
    Add_To_Favorite: "Add to favorite",
    Remove_From_Favorite: "Remove from favorite",
    Add_To_Favorite_Message_Text: "has been added to your favorites!",
    Remove_From_Favorite_Message_Text: "has been removed from your favorites!",
    Job_Filter: "Job Filter",
    Favorites: "Favorites",
    AccountSetup: "Account Setup",
    TakeTour: "Take Tour",
    RetakeTour: "Retake Tour",
    EnableWorkflows: "Enable Workflows",
    Enable_ATS: "Enable ATS",
    Enable_Message_Center: "Enable Message Center",
    Hide_Parent_PunchSets_In_Payroll: "Hide Parent Punch Sets In Payroll",
    Enable_Simple_Work_Preferences: "Enable Simple Work Preferences",
    Enable_GeoFence_Tracking: "Enable GeoFence Tracking",
    Plan: "Plan",
    PLG: "PLG",
    Marketing: "Marketing",
    Total_PEPM: "Total PEPM (Excluding Base)",
    SignUp_Date: "Signup Date",
    Industry: "Industry",
    Self_Reported_Employee_Size: "Self-Reported Employee Size",
    ProxyNotValidTitle: "Account Guest Error",
    ProxyNotValidDetails: "Account guest login is no longer valid. This may occur because you opened another guest account from the Account Manager. Please close this tab to continue.",
    BuildingServicesAndMaintanence: "Building Services and Maintenance",
    Construction: "Construction",
    HealthCare: "Healthcare",
    Janitorial: "Janitorial",
    Manufacturing: "Manufacturing",
    Security: "Security",
    TempStaffing: "Temp Staffing",
    ZeroTo10: "0-10",
    TenTo50: "10-50",
    FiftyTo250: "50-250",
    TwoFiftyTo500: "250-500",
    FiveHundredTo1500: "500-1500",
    FifteenHundredPlus: "1500+",
    GreaterThan10000: "> 10,000",
    FinddTestAccount: "Findd Test Account",
    SalesDemoAccount: "Sales Demo Account",
    EmployeePunchedLastMonth: "Employee Punched Last Month",
    EmployeePunchedCurrentMonth: "Employee Punched Current Month",
    BaseFee: "Base Fee",
    YearlyIncrease: "Yearly Increase",
    UTMSource: "UTM Source",
    UTMMedium: "UTM Medium",
    UTMCampaign: "UTM Campaign",
    UTMTerm: "UTM Term",
    UTMContent: "UTM Content",
    AdId: "Ad Id",
    AdsetId: "Adset Id",
    CampaignId: "Campaign Id",
    AdName: "Ad Name",
    AdsetName: "Adset Name",
    CampaignName: "Campaign Name",
    Placement: "Placement",
    SiteSourceName: "Site Source Name",
    LandingPage: "Landing Page",
    SendMobileAppSMS: "Send Mobile App Link",
    SendMessage: "Send Message",
    ReSendMobileAppSMS: "Resend Mobile App Link",
    MobileAppPhoneLabel: "Mobile Phone Number",
    Enter_Valid_Mobile_Number: "Please enter a valid mobile number",
    App_Link_Sent: "Mobile app link has been sent! Please check your phone.",
    Client: "Client",
    Account_Manager_Admin: "Account Manager Admin",
    PLG_Setup: "PLG Setup",
    PEPM: "PEPM",
    Date_Created: "Date Created",
    Date_Updated: "Date Updated",
    Training: "Training",
    AccountActive: "Account Active",
    AccountManager: "Account Manager",
    Select_Account_For_Which_You_Want_To_Add_Scheduled_Job: "Select Account For Which You Want To Add Scheduled Job",
    Select: "Select",
    Findd_Grandd_Central: "Findd Grandd Central",
    Findd_Account_Manager: "Findd Account Manager",
    Release_Updates: "Release Updates",
    Release_Update_Text: "Keep up to date on what's new with Findd as we release new Grandd Central and Mobile App Features!",
    Grandd_Central_Notification: "Grandd Central Notification",
    Marketing_Funnel: "Marketing Funnel",
    Potential_Clients_In_Funnel: "Potential Clients In Funnel",
    CAC: "CAC",
    LTV: "LTV",
    Cost_Per: "Cost Per",
    Stage: "Stage",
    Company_Type: "Company Type",
    Company_Size: "Company Size",
    Marketing_Info: "Marketing Info",
    Enter_Stage_Date: "Enter Stage Date",
    No_Of_Punching_Employees: "No. Of Punching Employees",
    Total_Potential_Employees: "Total Potential Employees",
    Total_Expected_Employees: "Total Expected Employees",
    Earnings_PEPM: "Earnings PEPM",
    Account_Manager_User_Selected: "1 Account Manager User Selected",
    x_Account_Manager_User_Selected: "{0} Account Manager User Selected",
    No_User_Found: "No User Found!",
    Account_Manager_Users: "Account Manager Users",
    User_Permissions: "User Permissions",
    View_Account_Manager_Users_Tab: "View Account Manager Users Tab",
    View_System_Tab: "View System Tab",
    View_Account_Manager_Clients: "View Account Manager Clients",
    Edit_Account_Manager_Client_Details: "Edit Account Manager Client Details",
    Add_Account_Manager_Client_Account: "Add Account Manager Client Account",
    Enter_Client_Account: "Enter Client Account",
    Accrual_Balance_Report: "Accrual Balance Report",
    Are_you_sure_you_want_to_download_the_Accrual_Balance_Report: "Are you sure you want to download the Accrual Balance Report?",
    To_which_Account_Manager_you_want_to_Navigate: "To which Account Manager you want to Navigate?",
    Monthly_Minimum: "Monthly Minimum",
    Account_Type: "Account Type",
    Test_Account: "Test Account",
    Client_Account: "Client Account",
    Demo_Account: "Demo Account",
    View_Scheduled_Jobs: "View Scheduled Jobs",
    Allow_Client_Viewing: "Allow Client Viewing",
    Client_Can_View: "Client Can View",
    Job_Type: "Job Type",
    All_Client_Scheduled_Jobs: "All Client Scheduled Jobs",
    Client_Accessible_Scheduled_Jobs: "Client Accessible Scheduled Jobs",
    Non_Client_Accessible_Scheduled_Jobs: "Non-Client Accessible Scheduled Jobs",
    AllowPunchFromPersonalDevice: "Allow Punch From Personal Device",
    SelfServiceLoginEnabled: "Self Service Login Enabled",
    MobileAgreementAccepted: "Findd Agreement Accepted",
    AccountAgreementAccepted: "Account Agreement Accepted",
    UserModified: "User Modified",
    Agency: "Agency",
    AssignPotentialClientRelationshipManager: "Assign Potential Client Relationship Manager",
    RelationshipManager: "Relationship Manager",
    Filter_By_Account: "Filter By Account",
    Export_Failed_Punches: "Export Failed Punches",
    View_Time_Reports: "View Time Reports",
    Employee_Import: "Employee Import",
    Are_you_sure_you_want_to_import_employees_This_cannot_be_undone: "Are you sure you want to import {0} employees? This cannot be undone.",
    Note_For_Supervisor_Assignment_Column: "Note for 'Supervisor Assignment' Column",
    Multiple_Entries_Must_Be_Separated_By: "Multiple entries must be separated by '|' character",
    Download_Sample_File: "Download Sample File",
    Shortlist: "Shortlist",
    Import_Job_Data: "Import Job Data",
    Are_you_sure_you_want_to_import_jobs_This_cannot_be_undone: "Are you sure you want to import {0} jobs? This cannot be undone.",
    Decline: "Decline",
    Give_Reason_To_Decline: "Please give a reason to decline",
    Successfully_declined: "Successfully declined!",
    Decline_Status: "Decline Status",
    Not_Declined: "Not Declined",
    Declined: "Declined",
    Already_Declined_Employee: "This employee is already declined!",
    You_Cant_Decline_Your_Own_Self: "You can't decline your ownself.",
    New_Job_Shift: "New Job Shift",
    Miles_To_Job: "Miles to Job",
    Enable_Note_Attributes: "Enable Note Attributes",
    DisableEmployeeApprovalException: "Disable Employee Approval Exceptions",
    DisableSupervisorApprovalException: "Disable Supervisor Approval Exceptions",
    DisableLocationExceptionWhenNoGPS: "Disable Location Exception When No Hierarchy/Job GPS Is Set",
    FillRate: "Fill Rate",
    PotentialCostSavings: "Potential Cost Savings",
    FTERatio: "FTE Factor",
    Disable_Employee_Approval_Exceptions_Notify: "Disable Employee Approval Exceptions Notify",
    Disable_Supervisor_Approval_Exception_Notify: "Disable Supervisor Approval Exceptions Notify",
    Disable_Creating_Location_Exception_When_No_GPS: "Disable Creating Location Exception When No Hierarchy/Job GPS Is Set",
    MedicalAccount: "Is Medical Account",
    DefaultCountry: "Default Country",
    Edit_Job_Location: "Edit Job Location",
    Dashboard_For_x: "Dashboard For {0}",
    Data_as_of_x: "Data as of {0}",
    Workforce_Optimization: "Workforce Optimization",
    Cost_Savings: "Cost Savings",
    Message_Group_Name: "Message Group Name",
    SentBy: "Sent By",
    Message_Members: "Members",
    Sent: "Sent",
    Message_Context: "Context",
    AutoReplyChatGPT: "Auto Reply to SMS using Chat GPT",
    EnableBlendedRateOT: "Enable Blended Rate OT",
    VIEW_ACCOUNT_SETTINGS_PIPELINES: "View Pipeline Settings",
    ADD_ACCOUNT_SETTINGS_PIPELINES: "Add Pipeline Settings",
    DELETE_ACCOUNT_SETTINGS_PIPELINES: "Delete Pipeline Settings",
    EDIT_ACCOUNT_SETTINGS_PIPELINES: "Edit Pipeline Settings",
    VIEW_ACCOUNT_SETTINGS_BADGES: "View Badge Settings",
    ADD_ACCOUNT_SETTINGS_BADGES: "Add Badge Settings",
    DELETE_ACCOUNT_SETTINGS_BADGES: "Delete Badge Settings",
    EDIT_ACCOUNT_SETTINGS_BADGES: "Edit Badge Settings",
    VIEW_ACCOUNT_SETTINGS_CREDENTIALS: "View Credential Settings",
    ADD_ACCOUNT_SETTINGS_CREDENTIALS: "Add Credential Settings",
    DELETE_ACCOUNT_SETTINGS_CREDENTIALS: "Delete Credential Settings",
    EDIT_ACCOUNT_SETTINGS_CREDENTIALS: "Edit Credential Settings",
    VIEW_ACCOUNT_SETTINGS_FILES: "View File Settings",
    ADD_ACCOUNT_SETTINGS_FILES: "Add File Settings",
    DELETE_ACCOUNT_SETTINGS_FILES: "Delete File Settings",
    EDIT_ACCOUNT_SETTINGS_FILES: "Edit File Settings",
    VIEW_ACCOUNT_SETTINGS_USERS: "View User Settings",
    ADD_ACCOUNT_SETTINGS_USERS: "Add User Settings",
    DELETE_ACCOUNT_SETTINGS_USERS: "Delete User Settings",
    EDIT_ACCOUNT_SETTINGS_USERS: "Edit User Settings",
    VIEW_ACCOUNT_SETTINGS_NOTES_CHECKLISTS: "View Notes & Checklist Settings",
    ADD_ACCOUNT_SETTINGS_NOTES_CHECKLISTS: "Add Notes & Checklist Settings",
    DELETE_ACCOUNT_SETTINGS_NOTES_CHECKLISTS: "Delete Notes & Checklist Settings",
    EDIT_ACCOUNT_SETTINGS_NOTES_CHECKLISTS: "Edit Notes & Checklist Settings",
    VIEW_ACCOUNT_SETTINGS_HR_JOBS: "View HR Job Settings",
    ADD_ACCOUNT_SETTINGS_HR_JOBS: "Add HR Job Settings",
    DELETE_ACCOUNT_SETTINGS_HR_JOBS: "Delete HR Job Settings",
    EDIT_ACCOUNT_SETTINGS_HR_JOBS: "Edit HR Job Settings",
    VIEW_ACCOUNT_SETTINGS_INTEGRATIONS: "View Integration Settings",
    ADD_ACCOUNT_SETTINGS_INTEGRATIONS: "Add Integration Settings",
    DELETE_ACCOUNT_SETTINGS_INTEGRATIONS: "Delete Integration Settings",
    EDIT_ACCOUNT_SETTINGS_INTEGRATIONS: "Edit Integration Settings",
    VIEW_PIPELINES: "View Pipelines",
    ADD_PIPELINES: "Add Pipelines",
    DELETE_PIPELINES: "Delete Pipelines",
    EDIT_PIPELINES: "Edit Pipelines",
    VIEW_BADGES: "View Badges",
    ADD_BADGES: "Add Badges",
    DELETE_BADGES: "Delete Badges",
    EDIT_BADGES: "Edit Badges",
    VIEW_HR_PEOPLE: "View HR People",
    ADD_HR_PEOPLE: "Add HR People",
    DELETE_HR_PEOPLE: "Delete HR People",
    EDIT_HR_PEOPLE: "Edit HR People",
    VIEW_CREDENTIALS: "View Credentials",
    ADD_CREDENTIALS: "Add Credentials",
    DELETE_CREDENTIALS: "Delete Credentials",
    EDIT_CREDENTIALS: "Edit Credentials",
    VIEW_DEMOGRAPHICS: "View Employee Demographics",
    EDIT_DEMOGRAPHICS: "Edit Employee Demographics",
    VIEW_GOVERNMENT_ID: "View Government Id",
    EDIT_GOVERNMENT_ID: "Edit Government Id",
    VIEW_CONTACT_INFO: "View Employee Contact Info",
    EDIT_CONTACT_INFO: "Edit Employee Contact Info",
    VIEW_LANGUAGE_ETHNICITY: "View Language & Ethnicity",
    EDIT_LANGUAGE_ETHNICITY: "Edit Language & Ethnicity",
    VIEW_EMPLOYEE_SPECIALTIES: "View Employee Specialities",
    ADD_EMPLOYEE_SPECIALTIES: "Add Employee Specialities",
    EDIT_EMPLOYEE_SPECIALTIES: "Edit Employee Specialities",
    DELETE_EMPLOYEE_SPECIALTIES: "Delete Employee Specialities",
    VIEW_EMPLOYEE_FILES: "View Employee Files",
    EDIT_EMPLOYEE_FILES: "Edit Employee Files",
    ADD_EMPLOYEE_FILES: "Add Employee Files",
    DELETE_EMPLOYEE_FILES: "Delete Employee Files",
    VIEW_EMPLOYEE_WORK_HISTORY: "View Employee Work History",
    ADD_EMPLOYEE_WORK_HISTORY: "Add Employee Work History",
    EDIT_EMPLOYEE_WORK_HISTORY: "Edit Employee Work History",
    DELETE_EMPLOYEE_WORK_HISTORY: "Delete Employee Work History",
    VIEW_EMPLOYEE_EDUCATION: "View Employee Education",
    ADD_EMPLOYEE_EDUCATION: "Add Employee Education",
    EDIT_EMPLOYEE_EDUCATION: "Edit Employee Education",
    DELETE_EMPLOYEE_EDUCATION: "Delete Employee Education",
    VIEW_EMPLOYEE_CREDENTIALS: "View Employee Credentials",
    ADD_EMPLOYEE_CREDENTIALS: "Add Employee Credentials",
    EDIT_EMPLOYEE_CREDENTIALS: "Edit Employee Credentials",
    DELETE_EMPLOYEE_CREDENTIALS: "Delete Employee Credentials",
    VIEW_EMPLOYEE_CHECKLISTS: "View Employee Checklists",
    ADD_EMPLOYEE_CHECKLISTS: "Add Employee Checklists",
    EDIT_EMPLOYEE_CHECKLISTS: "Edit Employee Checklists",
    DELETE_EMPLOYEE_CHECKLISTS: "Delete Employee Checklists",
    VIEW_EMPLOYEE_REFERENCES: "View Employee References",
    ADD_EMPLOYEE_REFERENCES: "Add Employee References",
    EDIT_EMPLOYEE_REFERENCES: "Edit Employee References",
    DELETE_EMPLOYEE_REFERENCES: "Delete Employee References",
    VIEW_EMPLOYEE_BADGES: "View Employee Badges",
    ADD_EMPLOYEE_BADGES: "Add Employee Badges",
    EDIT_EMPLOYEE_BADGES: "Edit Employee Badges",
    DELETE_EMPLOYEE_BADGES: "Delete Employee Badges",
    VIEW_EMPLOYEE_REWARDS: "View Employee Rewards",
    ADD_EMPLOYEE_REWARDS: "Add Employee Rewards",
    EDIT_EMPLOYEE_REWARDS: "Edit Employee Rewards",
    DELETE_EMPLOYEE_REWARDS: "Delete Employee Rewards",
    ALLOW_CHANGE_STATUS_VIA_PIPELINE: "Change Status/SubStatus via pipeline",
    ALLOW_CHANGE_STATUS_VIA_PROFILE_PAGE: "Change Status/SubStatus via profile page",
    ALLOW_CHANGE_EMAIL: "Change Email",
    ALLOW_CHANGE_MOBILE: "Change Number",
    HR_SETTINGS: "HR Settings",
    HR_USER_ACCESS: "HR User Access",
    HR_PEOPLE_ACCESS: "HR People Access",
    HR_MENU_ACCESS: "HR Access",
    HR_PEOPLE_DETAIL_ACCESS: "HR People Detail Access",
    Trends: "Trends",
    AllowMobileTimecardView: "Show Mobile Timecards",
    AllowMobileWorkView: "Show Mobile Work",
    AllowMobileScheduleView: "Show Mobile Schedules",
    AllowMobileLeaveTrackingView: "Show Mobile Leave Tracking",
    AllowMobileExpensesView: "Show Mobile Expenses",
    AllowMobileAdHocFilesView: "Show Mobile Files",
    ShowJobToMobileUsers: "Advertise Job To Mobile Users",
    Badge_Qualification: "Badge Qualification",
    AdHoc_Communication: "AdHoc Communication",
    Seniority_Date: "Seniority Date",
    No_Seniority_Date: "No Seniority Date",
    No_Start_Date: "No Start Date",
    Show_Thumbnail: "Show Thumbnail",
    Allow_Minimum_Break_Override: "Allow Minimum Break Override",
    greater_than_Minimum_Break_Duration: "greater than Min Break Duration",
    Alternate_PayType: "Alternate PayType",
    Alternate_PayType_if_break_is_less_than: "Alternate PayType if break is less than",
    Alternate_PayType_should_be_not_same_with_paytype: "Alternate PayType should be not same with paytype",
    Enable_Didi_Notifications: "Enable Didi Nudging",
    Phone_Number: "Phone Number",
    Phone_Number_and_Code: "Phone Number / Code",
    Biometric_Location_Exceptions_Report: "Biometric Location Exceptions Report",
}

export default en_us